/* MV Sortiment assets/mv-sortiment.js · generiert von _build/buendel.mjs · nicht von Hand bearbeiten */
/* Teile (7): assets/mv-sortiment.anfrage.js assets/mv-sortiment.cart.js assets/mv-sortiment.energielabel.js assets/mv-sortiment.m4.js assets/mv-sortiment.mobil.js assets/mv-sortiment.r2b.js assets/mv-sortiment.suche.js */

/* ==== Teil: assets/mv-sortiment.anfrage.js ==== */
/* MV Sortiment assets/mv-sortiment.anfrage.js - Paket LZ-2e - 2026-10-25
 *
 * Anfrage-Lightbox (snippets/mv-anfrage-modal.liquid) und Lead-Intake (snippets/mv-lead-intake.liquid) als Teil des
 * Basis-Buendels statt zweier Inline-Skripte vor </body> (Ladezeit Stufe 2, _docs/lz2-buendel-vertrag.md Abschnitt 2,
 * Bericht _docs/lz2-e-anfrage-asset.md). Beide Bloecke unten sind die bisherigen Inline-Skripte (D3-A, W-S, E-T2,
 * CG-1 mit Erfolgsseite) mit unveraendertem Verhalten; geaendert ist nur:
 *   - der einzige Liquid-Wert der Lightbox (mv_state: '' | 'success' | 'error') kommt aus
 *     <script type="application/json" id="mv-anfrage-daten">{"state": ...}</script> im Snippet;
 *   - Start der Lightbox: laeuft der Teil nach dem Parsen (Basis-Buendel mit defer oder type="module", vor
 *     DOMContentLoaded), sofort - wie bisher das Inline-Skript am Ende des body; laeuft er noch waehrend des Parsens,
 *     bei DOMContentLoaded. Klick-, change- und submit-Ereignisse bleiben am document delegiert (auch fuer Formulare
 *     und Oeffner, die spaeter eingesetzt werden);
 *   - Waechter window.__mvAnfrage (einziger neuer Global; { version, bereit, state }) gegen eine Zweitausfuehrung;
 *     der Waechter window.__mvLeadIntake des Lead-Intake bleibt (Inline-Kopie in templates/page.mv-landing.json);
 *   - ein Fehler beim Start wird asynchron gemeldet, damit die folgenden Teile des Buendels weiterlaufen;
 *   - reines ASCII (Mittelpunkt der Konfiguration als \u00b7 wie in ausKonfiguration).
 * Unter Node (ohne document) liefert die Datei die reinen Funktionen der Vorbelegung ueber module.exports
 * (_tests/lz2-e.test.mjs); der Lead-Intake-Block tut dort nichts.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-25.1';

  // D3-A: reine Funktionen der Vorbelegung (ohne DOM; unter Node ueber module.exports pruefbar).
  // Optionen und Muster stehen im Markup (snippets/mv-anfrage-felder.liquid), hier nur die Regeln.
  var STRICHE = /[\u2010-\u2015\u2212]/;
  var RAND = /^[\s\-\u2010-\u2015\u00b7,;:|\/]+|[\s\-\u2010-\u2015\u00b7,;:|\/]+$/g;

  // Ein Zeichen vergleichbar machen: klein, ohne Akzente, sz als ss, Striche als -, Leerraum als ein Leerzeichen
  function zeichenNorm(c) {
    var n = c.normalize ? c.normalize('NFKD') : c;
    n = n.replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\u00df/g, 'ss');
    if (STRICHE.test(n)) return '-';
    return /^\s+$/.test(n) ? ' ' : n;
  }

  // Text normalisieren; index[i] = Position des Zeichens i im Original (Rest mit Originalschreibung)
  function normalisiere(text) {
    var s = String(text == null ? '' : text);
    var aus = '';
    var index = [];
    for (var i = 0; i < s.length; i++) {
      var n = zeichenNorm(s.charAt(i));
      for (var k = 0; k < n.length; k++) {
        var c = n.charAt(k);
        if (c === ' ' && (!aus || aus.charAt(aus.length - 1) === ' ')) continue;
        aus += c;
        index.push(i);
      }
    }
    if (aus.charAt(aus.length - 1) === ' ') { aus = aus.slice(0, -1); index.pop(); }
    return { text: aus, index: index };
  }

  function wortzeichen(c) { return /[a-z0-9]/.test(c); }

  // Bester Eintrag fuer einen Text: laengstes Muster an Wortgrenzen; bei gleicher Laenge der erste Eintrag
  function bestesMuster(text, eintraege) {
    var t = normalisiere(text);
    var best = null;
    for (var e = 0; e < eintraege.length; e++) {
      var muster = eintraege[e].muster || [];
      for (var m = 0; m < muster.length; m++) {
        var nm = normalisiere(muster[m]).text;
        if (!nm || (best && nm.length <= best.laenge)) continue;
        var ab = t.text.indexOf(nm);
        while (ab !== -1) {
          var ende = ab + nm.length;
          var links = ab === 0 || !wortzeichen(t.text.charAt(ab - 1)) || !wortzeichen(nm.charAt(0));
          var rechts = ende === t.text.length || !wortzeichen(t.text.charAt(ende)) || !wortzeichen(nm.charAt(nm.length - 1));
          if (links && rechts) {
            best = { eintrag: eintraege[e], laenge: nm.length, ab: t.index[ab], bis: t.index[ende - 1] + 1 };
            break;
          }
          ab = t.text.indexOf(nm, ab + 1);
        }
      }
    }
    return best;
  }

  function saeubere(t) { return String(t || '').replace(RAND, '').replace(/\s+/g, ' '); }

  // Produkttitel eines Oeffners -> { wert, modell } oder null (dann "Noch unklar")
  function automatFuer(produkt, eintraege) {
    var t = String(produkt == null ? '' : produkt);
    var b = bestesMuster(t, eintraege);
    if (!b) return null;
    var modell = b.eintrag.modellAbTreffer ? t.slice(b.ab) : t.slice(b.bis);
    return { wert: b.eintrag.wert, modell: saeubere(modell).slice(0, 200) };
  }

  // data-konfiguration im Format von konfigurationsText() (assets/mv-sortiment.konfigurator.js)
  function ausKonfiguration(text) {
    var aus = { paket: '', menge: 0, aufAnfrage: [] };
    var teile = String(text || '').split(/\s+\u00b7\s+/);
    for (var i = 0; i < teile.length; i++) {
      var teil = teile[i].trim();
      var m;
      if ((m = /^Paket:\s*(.+)$/.exec(teil))) aus.paket = m[1];
      else if ((m = /^Menge:\s*(\d+)/.exec(teil))) aus.menge = parseInt(m[1], 10);
      else if ((m = /^Auf Anfrage:\s*(.+)$/.exec(teil))) aus.aufAnfrage = m[1].split(/\s*,\s*/);
    }
    return aus;
  }

  function anzahlFuer(menge, eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      if (menge > 0 && e.von !== null && menge >= e.von && (e.bis === null || menge <= e.bis)) return e.wert;
    }
    return '';
  }

  function aufstellungGewuenscht(liste) {
    for (var i = 0; i < (liste || []).length; i++) if (normalisiere(liste[i]).text.indexOf('aufstellung') === 0) return true;
    return false;
  }

  // Eintraege aus den Optionen eines Selects (Wert, Muster aus data-mv-muster, Rueckfall, Mengenbereich)
  function eintraegeAus(sel) {
    var liste = [];
    if (!sel) return liste;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (!o.value) continue;
      var extra = o.getAttribute('data-mv-muster');
      var unklar = o.hasAttribute('data-mv-unklar');
      liste.push({
        wert: o.value,
        muster: unklar ? [] : [o.value].concat(extra ? extra.split('|') : []),
        modellAbTreffer: o.getAttribute('data-mv-modell') === 'treffer',
        unklar: unklar,
        von: o.hasAttribute('data-mv-von') ? parseInt(o.getAttribute('data-mv-von'), 10) : null,
        bis: o.hasAttribute('data-mv-bis') ? parseInt(o.getAttribute('data-mv-bis'), 10) : null
      });
    }
    return liste;
  }

  function waehle(sel, wert) {
    if (!sel || !wert) return false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === wert) { sel.selectedIndex = i; return true; }
    }
    return false;
  }

  // Felder <praefix>-* aus Produkttitel und Konfiguration vorbelegen; eigene Eingaben im Modell bleiben stehen
  function vorbelegen(praefix, produkt, konfiguration) {
    var automat = document.getElementById(praefix + '-automat');
    var modell = document.getElementById(praefix + '-modell');
    if (produkt && automat) {
      var eintraege = eintraegeAus(automat);
      var treffer = automatFuer(produkt, eintraege);
      var wert = treffer ? treffer.wert : '';
      for (var i = 0; !wert && i < eintraege.length; i++) if (eintraege[i].unklar) wert = eintraege[i].wert;
      waehle(automat, wert);
      if (modell && (!modell.value || modell.value === modell.getAttribute('data-mv-auto'))) {
        modell.value = treffer ? treffer.modell : '';
        modell.setAttribute('data-mv-auto', modell.value);
      }
    }
    var k = ausKonfiguration(konfiguration);
    var zahlung = document.getElementById(praefix + '-zahlungssystem');
    var paket = k.paket && zahlung ? bestesMuster(k.paket, eintraegeAus(zahlung)) : null;
    if (paket) waehle(zahlung, paket.eintrag.wert);
    var anzahl = document.getElementById(praefix + '-anzahl');
    if (k.menge && anzahl) waehle(anzahl, anzahlFuer(k.menge, eintraegeAus(anzahl)));
    var aufstellung = document.getElementById(praefix + '-aufstellung');
    if (aufstellung && aufstellungGewuenscht(k.aufAnfrage)) aufstellung.checked = true;
  }

  // E-T2: Ersatzteil der Anfrage (contact[Teil], contact[Seriennummer], Gruppe [data-mv-et2-teilfelder] in
  // snippets/mv-anfrage-felder.liquid). Die Gruppe steht nur da (und sendet nur dann), wenn ein Teil vorbelegt ist
  // oder "Service und Ersatzteile" gewaehlt ist; vorbelegt wird wie die Nachricht nur ein leeres Feld oder eines mit
  // der letzten Vorbelegung (Merker data-mv-vorbelegt), hoechstens 200 Zeichen, Leerraum zusammengefasst.
  function teilText(t) { return String(t == null ? '' : t).replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, 200); }
  function teilZeigen(praefix) {
    var feld = document.getElementById(praefix + '-teil');
    var box = feld && feld.closest ? feld.closest('[data-mv-et2-teilfelder]') : null;
    if (!box) return;
    var interesse = document.getElementById(praefix + '-interesse');
    var an = !!((interesse && /^Service/.test(interesse.value || '')) || feld.value);
    box.hidden = !an;
    var felder = box.querySelectorAll('input');
    for (var i = 0; i < felder.length; i++) felder[i].disabled = !an;
  }
  function teilVorbelegen(praefix, teil) {
    var feld = document.getElementById(praefix + '-teil');
    if (!feld) return;
    var wert = teilText(teil);
    var vorbelegt = feld.getAttribute('data-mv-vorbelegt');
    if (wert) {
      if (!feld.value || feld.value === vorbelegt) {
        feld.value = wert;
        feld.setAttribute('data-mv-vorbelegt', wert);
      }
    } else if (vorbelegt !== null && feld.value === vorbelegt) {
      feld.value = '';
      feld.removeAttribute('data-mv-vorbelegt');
    }
    teilZeigen(praefix);
  }

  // Nur ohne DOM (Node-Test) exportieren, im Browser nie ein fremdes module anfassen
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module && module.exports) {
      module.exports = {
        normalisiere: normalisiere, bestesMuster: bestesMuster, automatFuer: automatFuer, ausKonfiguration: ausKonfiguration,
        anzahlFuer: anzahlFuer, aufstellungGewuenscht: aufstellungGewuenscht, eintraegeAus: eintraegeAus, vorbelegen: vorbelegen
      };
    }
    return;
  }

  // LZ-2e: Waechter gegen eine Zweitausfuehrung (Basis-Buendel und ein spaeterer module-Tag laden dieselbe Datei)
  if (window.__mvAnfrage) return;
  var zustand = window.__mvAnfrage = { version: VERSION, bereit: false, state: '' };

  // LZ-2e: Liquid-Werte der Lightbox aus <script type="application/json" id="mv-anfrage-daten"> (Snippet)
  function daten() {
    var el = document.getElementById('mv-anfrage-daten');
    if (!el) return {};
    try {
      var d = JSON.parse(el.textContent || '{}');
      return d && typeof d === 'object' ? d : {};
    } catch (_) { return {}; }
  }

  function start() {
    zustand.bereit = true;
    // Kontaktseite: dasselbe Feld-Snippet mit praefix mv-kontakt, vorbelegt aus ?produkt= und ?konfiguration=
    if (document.getElementById('mv-kontakt-form')) {
      try {
        var seite = new URLSearchParams(location.search);
        if (seite.get('produkt') || seite.get('konfiguration')) vorbelegen('mv-kontakt', seite.get('produkt') || '', seite.get('konfiguration') || '');
        teilVorbelegen('mv-kontakt', seite.get('teil') || '');
      } catch (_) {}
    }
    // E-T2: Wahl bei "Interesse an" zeigt bzw. verbirgt die Ersatzteil-Felder (Lightbox und Kontaktseite)
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.id === 'mv-anfrage-interesse') teilZeigen('mv-anfrage');
      else if (t && t.id === 'mv-kontakt-interesse') teilZeigen('mv-kontakt');
    });

    var dlg = document.getElementById('mv-anfrage');
    if (!dlg) return;
    var d = daten();
    var state = typeof d.state === 'string' ? d.state : '';
    zustand.state = state;
    var automatWahl = document.getElementById('mv-anfrage-automat');
    // Kontextkarte: gewaehlte Automat-Option (nur textContent)
    function zeigeAutomat() {
      var zeile = document.getElementById('mv-anfrage-automat-anzeige');
      var wert = document.getElementById('mv-anfrage-automat-wert');
      if (!zeile || !wert) return;
      var text = automatWahl ? automatWahl.value : '';
      wert.textContent = text;
      zeile.hidden = !text;
    }
    if (automatWahl) automatWahl.addEventListener('change', zeigeAutomat);
    // Kontextkarte: Produkt und Konfiguration so, wie sie in den Hidden-Feldern stehen (nur textContent, nie HTML)
    function zeigeKontext(prod, konf, opts) {
      var titel = document.getElementById('mv-anfrage-produkt-anzeige');
      // E-T2: Oeffner mit data-teil zeigen das Teil als Titel der Kontextkarte (statt "Ersatzteil-Anfrage")
      if (titel) titel.textContent = teilText(opts && opts.teil) || (prod && prod.value) || titel.getAttribute('data-standard') || '';
      var anzeige = document.getElementById('mv-anfrage-konfiguration-anzeige');
      if (!anzeige) return;
      var text = konf ? konf.value : String(opts.konfiguration || '');
      while (anzeige.firstChild) anzeige.removeChild(anzeige.firstChild);
      if (text) {
        var kopf = document.createElement('p');
        kopf.className = 'mv-anfrage__konf-titel';
        kopf.textContent = 'Ihre Konfiguration';
        anzeige.appendChild(kopf);
        var liste = document.createElement('ul');
        liste.className = 'mv-anfrage__konf-liste';
        var teile = text.split(/\s+\u00b7\s+/);
        for (var k = 0; k < teile.length; k++) {
          if (!teile[k]) continue;
          var punkt = document.createElement('li');
          punkt.className = 'mv-anfrage__konf-punkt';
          punkt.textContent = teile[k];
          liste.appendChild(punkt);
        }
        anzeige.appendChild(liste);
      }
      anzeige.hidden = !text;
    }
    function openBox(opts) {
      opts = opts || {};
      var sel = document.getElementById('mv-anfrage-interesse');
      var prod = document.getElementById('mv-anfrage-produkt');
      var konf = document.getElementById('mv-anfrage-konfiguration');
      var standort = document.getElementById('mv-anfrage-standorttyp');
      if (sel && opts.interesse) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value.indexOf(opts.interesse) === 0) { sel.selectedIndex = i; break; }
        }
      }
      if (prod && opts.produkt) prod.value = opts.produkt;
      if (konf) konf.value = String(opts.konfiguration || '').slice(0, 900);
      // W-S: data-nachricht belegt die Nachricht vor, solange sie leer ist oder noch die letzte Vorbelegung traegt
      var nachricht = dlg.querySelector('textarea[name="contact[body]"]');
      if (nachricht && opts.nachricht) {
        var vorbelegt = nachricht.getAttribute('data-mv-vorbelegt');
        if (!nachricht.value || nachricht.value === vorbelegt) {
          nachricht.value = String(opts.nachricht).slice(0, 2000);
          nachricht.setAttribute('data-mv-vorbelegt', nachricht.value);
        }
      }
      vorbelegen('mv-anfrage', opts.produkt, opts.konfiguration);
      // E-T2: data-teil belegt contact[Teil] vor und zeigt die Ersatzteil-Felder (auch bei "Service und Ersatzteile")
      teilVorbelegen('mv-anfrage', opts.teil || '');
      // Oeffner ohne Produkt (z. B. Kopfzeile): bei leerer Auswahl der Automat der Produktseite, nie "Noch unklar"
      var standard = document.getElementById('mv-anfrage-produkt-anzeige');
      if (!opts.produkt && automatWahl && !automatWahl.value && standard) {
        var seitenTreffer = automatFuer(standard.getAttribute('data-standard'), eintraegeAus(automatWahl));
        if (seitenTreffer) waehle(automatWahl, seitenTreffer.wert);
      }
      zeigeAutomat();
      zeigeKontext(prod, konf, opts);
      if (standort && opts.standorttyp) {
        var gesucht = String(opts.standorttyp).trim();
        for (var j = 0; j < standort.options.length; j++) {
          if (standort.options[j].value && standort.options[j].value === gesucht) { standort.selectedIndex = j; break; }
        }
      }
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      var first = automatWahl || dlg.querySelector('input[name="contact[name]"]');
      if (first && !state) setTimeout(function () { first.focus(); }, 60);
    }
    function closeBox() { if (dlg.open) dlg.close(); else dlg.removeAttribute('open'); }
    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-mv-close]');
      if (closer && dlg.contains(closer)) { e.preventDefault(); closeBox(); return; }
      var a = e.target.closest('a[href*="anfrage=1"], [data-mv-open-anfrage]');
      if (!a) return;
      e.preventDefault();
      var u = null; try { u = new URL(a.getAttribute('href'), location.origin); } catch (_) {}
      openBox({
        interesse: a.getAttribute('data-interesse') || (u && u.searchParams.get('interesse')) || '',
        produkt: a.getAttribute('data-produkt') || (u && u.searchParams.get('produkt')) || '',
        konfiguration: a.getAttribute('data-konfiguration') || (u && u.searchParams.get('konfiguration')) || '',
        standorttyp: a.getAttribute('data-standorttyp') || (u && u.searchParams.get('standorttyp')) || '',
        nachricht: a.getAttribute('data-nachricht') || '',
        teil: a.getAttribute('data-teil') || (u && u.searchParams.get('teil')) || ''
      });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeBox(); });
    if (state && location.search.indexOf('contact_posted=true') > -1 && !document.getElementById('mv-kontakt-form')) {
      openBox({});
      if (state === 'success' && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        try { Shopify.analytics.publish('mv_anfrage_gesendet', { quelle: 'lightbox', pfad: location.pathname }); } catch (_) {}
      }
    }
  }

  // LZ-2e: ein Fehler beim Start meldet sich asynchron (Konsole, window.onerror) und haelt das Buendel nicht an
  function sicherStarten() {
    try { start(); } catch (e) { setTimeout(function () { throw e; }, 0); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sicherStarten);
  else sicherStarten();
})();

;(function () {
  'use strict';

  // LZ-2e: unter Node (Test der reinen Funktionen oben) gibt es weder window noch document
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  try { leadIntake(); } catch (e) { setTimeout(function () { throw e; }, 0); }

  // MV Lead-Intake (08.09.2026, Paket CG-1 2026-10-23, Erfolgsseite 24.10.2026; Beschreibung im Kopfkommentar von
  // snippets/mv-lead-intake.liquid): jede Absendung eines Shopify-Kontaktformulars (action /contact, form_type=contact)
  // geht parallel zum nativen Post als JSON (fetch keepalive, text/plain) an die Function mv-lead-intake; der native
  // Submit wird nie blockiert.
  function leadIntake() {
    if (window.__mvLeadIntake) return;
    window.__mvLeadIntake = true;
    var ZIEL = 'https://fotzbrpfejfufbtvxmpq.supabase.co/functions/v1/mv-lead-intake';
    var HP = 'firmenwebsite';

    function istKontaktformular(f) {
      if (!f || !f.tagName || f.tagName !== 'FORM') return false;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/contact') === -1) return false;
      var typ = f.querySelector('input[name="form_type"]');
      return !!typ && typ.value === 'contact';
    }

    function honeypotEinsetzen(f) {
      if (f.querySelector('input[name="' + HP + '"]')) return;
      var hp = document.createElement('input');
      hp.type = 'text'; hp.name = HP; hp.tabIndex = -1; hp.autocomplete = 'off';
      hp.setAttribute('aria-hidden', 'true');
      hp.style.cssText = 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;opacity:0;pointer-events:none';
      f.appendChild(hp);
    }

    function alleVorbereiten() {
      var forms = document.querySelectorAll('form[action*="/contact"]');
      for (var i = 0; i < forms.length; i++) if (istKontaktformular(forms[i])) honeypotEinsetzen(forms[i]);
    }

    function felder(f) {
      var out = {};
      var elemente = f.elements;
      for (var i = 0; i < elemente.length; i++) {
        var el = elemente[i];
        var name = el.name || '';
        var m = /^contact\[(.+)\]$/.exec(name);
        if (!m) continue;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
        if (el.type === 'file') continue;
        out[m[1]] = String(el.value || '');
      }
      return out;
    }

    // Paket CG-1: OpenAI-Pixel (snippets/mv-openai-pixel.liquid), nur mit Marketing-Zustimmung
    function openaiErlaubt() {
      var p = window.__mvOpenaiPixel;
      return !!p && p.erlaubt === true && typeof window.oaiq === 'function';
    }

    // UUID v4; Rueckfall mv-<Zeit base36>-<16 Hex>; hoechstens 64 Zeichen
    function ereignisId() {
      var c = window.crypto;
      if (c && typeof c.randomUUID === 'function') return String(c.randomUUID()).slice(0, 64);
      var hex = '';
      if (c && typeof c.getRandomValues === 'function') {
        var b = c.getRandomValues(new Uint8Array(8));
        for (var i = 0; i < b.length; i++) hex += (b[i] < 16 ? '0' : '') + b[i].toString(16);
      } else {
        for (var j = 0; j < 16; j++) hex += Math.floor(Math.random() * 16).toString(16);
      }
      return ('mv-' + Date.now().toString(36) + '-' + hex).slice(0, 64);
    }

    function keks(name) {
      var teile = document.cookie ? document.cookie.split(';') : [];
      for (var i = 0; i < teile.length; i++) {
        var t = teile[i].replace(/^\s+/, '');
        if (t.indexOf(name + '=') !== 0) continue;
        var w = t.slice(name.length + 1);
        try { return decodeURIComponent(w); } catch (e) { return w; }
      }
      return '';
    }

    function urlParameter(name) {
      try { return new URL(location.href).searchParams.get(name) || ''; } catch (e) { return ''; }
    }

    // Referenz unveraendert weitergeben: druckbares ASCII ohne Leerzeichen bis max Zeichen, sonst weglassen
    function referenz(wert, max) {
      var s = String(wert || '');
      return s.length <= max && /^[\x21-\x7e]+$/.test(s) ? s : '';
    }

    // vor dem fetch: lead_created ans Pixel, dieselbe event_id und die Referenzen ins JSON (leere weglassen). Dieselbe
    // Absendung noch einmal auf derselben Seite (Doppelklick, erneuter Klick waehrend Shopifys Captcha): dieselbe
    // event_id, kein zweites measure - die Function verwirft die Wiederholung (Dedupe), OpenAI zaehlte sonst zweimal
    var letzte = null;
    function openaiMessen(daten) {
      try {
        if (!openaiErlaubt() || daten.hp) return;
        var schluessel = daten.form_id + '\n' + JSON.stringify(daten.felder);
        var wieder = !!letzte && letzte.schluessel === schluessel;
        var id = wieder ? letzte.id : ereignisId();
        var oppref = referenz(keks('__oppref'), 256) || referenz(urlParameter('oppref'), 256);
        var obref = referenz(keks('__obref'), 128);
        if (!wieder) window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: id });
        letzte = { schluessel: schluessel, id: id };
        merke(id);
        daten.event_id = id;
        if (oppref) daten.oppref = oppref;
        if (obref) daten.obref = obref;
      } catch (e) { /* nie den Submit stoeren */ }
    }

    // Erfolgsseite (Nachtrag 24.10.2026): der native Post navigiert sofort weiter und kann das gebuendelte Senden des SDK
    // abschneiden. Die gemessene event_id bleibt 10 Minuten in sessionStorage; auf der Seite mit ?contact_posted=true
    // misst der Handler sie mit Zustimmung noch einmal (OpenAI zaehlt je event_id das erste Ereignis), hoechstens einmal
    var ERFOLG_SCHLUESSEL = 'mv_oai_lead';
    var ERFOLG_MAX_MS = 600000;
    var erfolgFertig = false;

    function merke(id) {
      try { window.sessionStorage.setItem(ERFOLG_SCHLUESSEL, JSON.stringify({ event_id: id, t: Date.now() })); } catch (e) { /* ohne Speicher keine Nachmessung */ }
    }

    function istErfolgsseite() {
      return /[?&]contact_posted=true(&|$)/.test(location.search);
    }

    function erfolgsseite() {
      try {
        if (erfolgFertig || !istErfolgsseite() || !openaiErlaubt()) return;
        var roh = window.sessionStorage.getItem(ERFOLG_SCHLUESSEL);
        if (!roh) return;
        erfolgFertig = true;
        window.sessionStorage.removeItem(ERFOLG_SCHLUESSEL);
        var eintrag = JSON.parse(roh);
        var alter = Date.now() - Number(eintrag && eintrag.t);
        if (!eintrag || typeof eintrag.event_id !== 'string' || !/^[A-Za-z0-9._:-]{1,64}$/.test(eintrag.event_id) || !(alter >= 0 && alter < ERFOLG_MAX_MS)) return;
        window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eintrag.event_id });
        window.__mvOpenaiPixel.erfolgGemessen = eintrag.event_id;
      } catch (e) { /* nie die Seite stoeren */ }
    }

    function senden(f) {
      var hp = f.querySelector('input[name="' + HP + '"]');
      var daten = {
        felder: felder(f),
        form_id: f.id || '',
        seite: location.href,
        hp: hp ? hp.value : ''
      };
      openaiMessen(daten);
      var body = JSON.stringify(daten);
      try {
        if (window.fetch) {
          fetch(ZIEL, { method: 'POST', keepalive: true, mode: 'cors', credentials: 'omit',
            headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
        } else if (navigator.sendBeacon) {
          navigator.sendBeacon(ZIEL, body);
        }
      } catch (e) { /* nie den Submit stoeren */ }
    }

    // Capture-Phase: laeuft vor Shopifys Captcha-Handler, der den Submit
    // abfangen und das Formular spaeter per form.submit() (ohne Ereignis)
    // erneut abschicken kann. Die HTML5-Pflichtfeldpruefung ist zu diesem
    // Zeitpunkt bereits bestanden.
    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (!istKontaktformular(f)) return;
      try { senden(f); } catch (e) { /* nie den Submit stoeren */ }
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleVorbereiten);
    else alleVorbereiten();

    // Paket CG-1, Erfolgsseite: sofort, bei DOMContentLoaded, bei load und nach 2 s und 6 s pruefen - die Zustimmung meldet
    // die Customer Privacy API meist erst nach DOMContentLoaded; gemessen wird hoechstens einmal
    if (istErfolgsseite()) {
      erfolgsseite();
      document.addEventListener('DOMContentLoaded', erfolgsseite);
      window.addEventListener('load', erfolgsseite);
      setTimeout(erfolgsseite, 2000);
      setTimeout(erfolgsseite, 6000);
    }
  }
})();

;

/* ==== Teil: assets/mv-sortiment.cart.js ==== */
/* MV Sortiment assets/mv-sortiment.cart.js - Agent T-B - 2026-10-02
 *
 * Mengen-Synchronisation der verschachtelten Warenkorbzeilen (Nested Cart Lines) in der Theme-Kopie
 * (Impact 6.12.0). Teil von assets/mv-sortiment.js, laedt allein und in beliebiger Reihenfolge.
 *
 * Shopify entfernt Kinder mit der Elternzeile, zieht ihre Menge aber nicht nach. Deshalb:
 *  - Drawer: Impacts LineItemQuantity feuert nach POST cart/change.js auf <line-item> das Event
 *    line-item:change (bubbles, detail {quantity, cart}). Traegt die Zeile data-mv-konfig (Patch
 *    _patches/snippets__line-item.liquid.md), werden ihre Kinder (cart.items mit
 *    parent_relationship.parent_key === Elternschluessel und Property _je_automat) nacheinander per
 *    POST cart/change.js {id, quantity: Elternmenge x _je_automat} angeglichen, danach cart:refresh.
 *  - Elternzeile entfernt (quantity 0): Sicherheitsnetz cart:refresh, falls nach Impacts verzoegertem
 *    Drawer-Austausch (1250 ms) noch Kinder [data-mv-kind-von] im DOM stehen.
 *  - Warenkorbseite: Impact laedt dort nach jeder Mengenaenderung neu (pageType "cart") und feuert kein
 *    line-item:change. Beim Laden der Seite wird daher einmal abgeglichen und bei Abweichung neu geladen
 *    (Schleifenschutz ueber sessionStorage).
 * Nur Kinder mit _je_automat (vom Konfigurator angelegt) werden angefasst, nie fremde Zeilen.
 * Kommentare ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-02.1';

  // ===========================================================================================
  // Reine Logik
  // ===========================================================================================

  // Liefert [{key, quantity}] fuer alle eigenen Kinder, deren Menge nicht Elternmenge x _je_automat ist.
  // Ohne elternKey: alle Elternzeilen. Verwaiste Kinder (Elternzeile fehlt) bleiben unberuehrt.
  function korrekturen(cart, elternKey) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var nachKey = {};
    items.forEach(function (it) {
      if (it && it.key) nachKey[it.key] = it;
    });
    var ergebnis = [];
    items.forEach(function (it) {
      if (!it || !it.key) return;
      var beziehung = it.parent_relationship;
      var parentKey = beziehung && beziehung.parent_key;
      if (!parentKey) return;
      if (elternKey && parentKey !== elternKey) return;
      var je = parseInt(it.properties && it.properties._je_automat, 10);
      if (!(je >= 1)) return;
      if (it.instructions && it.instructions.can_update_quantity === false) return;
      var eltern = nachKey[parentKey];
      if (!eltern || !(eltern.quantity >= 1)) return;
      var soll = eltern.quantity * je;
      if (it.quantity !== soll) ergebnis.push({ key: it.key, quantity: soll });
    });
    return ergebnis;
  }

  var logik = { VERSION: VERSION, korrekturen: korrekturen };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.cart) return;

  var SPEICHER = 'mv-cart-abgleich';
  var api = MV.cart = {
    version: VERSION,
    logik: logik,
    netzMs: 1600,          // nach Impacts 1250-ms-Austausch des Drawer-Inhalts
    abgleichPauseMs: 10000 // Schleifenschutz Warenkorbseite
  };

  var kette = Promise.resolve();
  var stand = 0; // zaehlt eigene Aenderungen; aeltere Event-Carts werden danach neu geladen

  function routenWurzel() {
    var s = window.Shopify;
    return (s && s.routes && s.routes.root) || '/';
  }

  function themeEinstellungen() {
    var t = window.themeVariables;
    return (t && t.settings) || {};
  }

  function attr(name, wert) {
    return '[' + name + '="' + String(wert).replace(/["\\]/g, '\\$&') + '"]';
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function holeCart() {
    return fetch(routenWurzel() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Nacheinander, damit Shopify die Aenderungen nicht gegeneinander verrechnet; Abbruch beim ersten Fehler
  async function wendeAn(liste) {
    var erledigt = 0;
    for (var i = 0; i < liste.length; i++) {
      var antwort = await fetch(routenWurzel() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: liste[i].key, quantity: liste[i].quantity })
      });
      if (!antwort || !antwort.ok) break;
      erledigt += 1;
    }
    return erledigt;
  }

  function elternZeile(el) {
    if (!el || !el.getAttribute) return null;
    if (el.matches && el.matches('[data-mv-konfig]')) return el;
    return (el.querySelector && el.querySelector('[data-mv-konfig]')) || (el.closest && el.closest('[data-mv-konfig]')) || null;
  }

  function elternKeyVon(zeile, eltern, cart, konfig) {
    var key = eltern.getAttribute('data-mv-line-key');
    if (key) return key;
    var eingabe = zeile.querySelector && zeile.querySelector('[data-line-key]');
    if (eingabe) return eingabe.getAttribute('data-line-key');
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && !it.parent_relationship && it.properties && it.properties._konfig === konfig) return it.key;
    }
    return null;
  }

  async function synchronisiere(elternKey, cart, standBeimEreignis) {
    if (!cart || !Array.isArray(cart.items) || stand !== standBeimEreignis) cart = await holeCart();
    var liste = korrekturen(cart, elternKey);
    if (!liste.length) return;
    try {
      await wendeAn(liste);
    } finally {
      stand += 1;
      refresh();
    }
  }

  function sicherheitsnetz(konfig) {
    setTimeout(function () {
      if (!konfig || document.querySelector(attr('data-mv-kind-von', konfig))) refresh();
    }, api.netzMs);
  }

  document.addEventListener('line-item:change', function (e) {
    var zeile = e.target;
    var eltern = elternZeile(zeile);
    if (!eltern) return;
    var detail = e.detail || {};
    var konfig = eltern.getAttribute('data-mv-konfig') || '';
    if (detail.quantity === 0) {
      sicherheitsnetz(konfig);
      return;
    }
    var key = elternKeyVon(zeile, eltern, detail.cart, konfig);
    if (!key) return;
    var standBeimEreignis = stand;
    kette = kette
      .then(function () { return synchronisiere(key, detail.cart, standBeimEreignis); })
      .catch(function () { refresh(); });
  });

  async function abgleichWarenkorbseite() {
    if (themeEinstellungen().pageType !== 'cart') return;
    var cart = await holeCart();
    var liste = korrekturen(cart);
    if (!liste.length) return;
    var signatur = liste.map(function (k) { return k.key + '=' + k.quantity; }).join('|');
    var jetzt = Date.now();
    var letzter = null;
    try {
      letzter = JSON.parse(window.sessionStorage.getItem(SPEICHER) || 'null');
    } catch (e) {
      letzter = null;
    }
    if (letzter && letzter.signatur === signatur && jetzt - letzter.zeit < api.abgleichPauseMs) return;
    var schutz = true;
    try {
      window.sessionStorage.setItem(SPEICHER, JSON.stringify({ signatur: signatur, zeit: jetzt }));
    } catch (e) {
      schutz = false; // ohne Speicher kein Schleifenschutz: Mengen angleichen, aber nicht neu laden
    }
    await wendeAn(liste);
    if (schutz) window.location.reload();
  }

  function start() {
    abgleichWarenkorbseite().catch(function () { /* naechster Seitenaufruf versucht es erneut */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

;

/* ==== Teil: assets/mv-sortiment.energielabel.js ==== */
/* MV Sortiment assets/mv-sortiment.energielabel.js - Paket E-L-2a - 2026-10-12
 *
 * EU-Energielabel der gekuehlten SandenVendo-Geraete (Delegierte VO (EU) 2019/2018, Anhang VIII: Fernabsatz). Inhaber
 * 12.10.2026: "Setz es fuer Sanden Vendo komplett um". Doku: _docs/el2-energielabel-theme.md. Teil von
 * assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge mit den anderen Teilen; nur
 * Delegation auf document, kein Inline-Skript.
 *
 * 1. Bausteine (rein, unter Node ueber module.exports pruefbar): pfeilHtml, linkHtml, karteHtml, infoHtml liefern
 *    byte-gleich das Markup von snippets/mv-energielabel.liquid (Teile pfeil, karte, kaufbox) fuer einen Eintrag des
 *    Datenblocks { klasse, ziel, kwh, kategorie, eprel, label, breite, hoehe, datenblatt, titel } bzw. { rueckfall: true }.
 *    Der Finder (assets/mv-sortiment.finder.js) haengt den Teil karte als Knoten ein
 *    (window.__mvSortiment.energielabel.karteKnoten; er selbst setzt kein innerHTML).
 * 2. Lightbox: Klick oder Tippen auf einen Pfeil [data-mv-energie-pfeil] mit Label-Bild (data-mv-energie-label) oeffnet
 *    einen dialog (einmal je Seite, hier gebaut) mit dem Label in der gelieferten Groesse (nie schmaler als 96 mm,
 *    Anhang III Nr. 4; Rahmen scrollt), Werten, Link "Produktdatenblatt" und Quelle EPREL. showModal() bringt Fokusfalle
 *    und Escape; ohne showModal Ersatzebene mit Fokusfalle und Escape aus diesem Skript. Schliessen gibt den Fokus an den
 *    Pfeil zurueck. Ohne Label-Bild (nur EPREL-Seite) und bei Klick mit Zusatztaste bleibt der Link ein Link (neuer Tab).
 * 3. Variantenwechsel: mv:konf:change (Konfigurator, grund variante/rerender/konto) und variant:change (Impact) fuellen
 *    die Slots [data-mv-energie-slot][data-mv-energie-form="<formId>"] (Pfeil in der Preiszeile und in der Sticky-Leiste,
 *    Zeile mit Link oder Rueckfalltext) aus script[data-mv-energielabel-daten="<formId>"] neu; Slots, die schon die
 *    Variante zeigen (data-mv-energie-variante, etwa nach Impacts Austausch der Bloecke), bleiben unberuehrt.
 *
 * Kommentare ASCII; sichtbare Texte als \u-Escapes (Textbloecke ENL-01 bis ENL-09 der Doku).
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-12.1';

  // Sichtbare Texte (Sie-Form, Klartext in Klammern transliteriert)
  var TEXTE = {
    pfeilAria: 'Energieeffizienzklasse {klasse}, Skala A bis G', // ENL-01
    datenblatt: 'Produktdatenblatt', // ENL-02
    rueckfall: 'F\u00fcr dieses Modell liegt das EU-Energielabel noch nicht vor. Sobald der Hersteller Label und Produktdatenblatt bereitstellt, erg\u00e4nzen wir beides hier.', // ENL-03 (Fuer ... ergaenzen ...)
    dialogTitel: 'EU-Energielabel', // ENL-04
    klasse: 'Energieeffizienzklasse {klasse}', // ENL-05
    verbrauch: 'Energieverbrauch {kwh} kWh/Jahr', // ENL-05
    kategorie: '(Kategorie {kategorie})', // ENL-05
    alt: 'EU-Energielabel {titel}: Energieeffizienzklasse {klasse}', // ENL-06
    altVerbrauch: ', Energieverbrauch {kwh} kWh/Jahr', // ENL-06
    labelTab: 'Energielabel in neuem Tab \u00f6ffnen', // ENL-07 (oeffnen)
    quelle: 'Quelle: EPREL, die Produktdatenbank der Europ\u00e4ischen Kommission f\u00fcr die Energieverbrauchskennzeichnung.', // ENL-08
    eprelLink: 'Eintrag in der EPREL-Datenbank', // ENL-08
    schliessen: 'Schlie\u00dfen' // ENL-09 (Schliessen)
  };

  var PUNKT = ' \u00b7 ';
  var STRICH = '\u2013';
  var KLASSEN = 'ABCDEFG';
  var EPREL_SEITE = 'https://eprel.ec.europa.eu/screen/product/refrigeratingappliancesdirectsalesfunction/';

  // ===========================================================================================
  // Reine Logik
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).replace(/^\s+|\s+$/g, '');
  }

  // Wie Liquid escape: & < > " '
  function maskiere(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function klasseVon(x) {
    var k = text(x).toUpperCase();
    return k.length === 1 && KLASSEN.indexOf(k) !== -1 ? k : '';
  }

  // Ganze Zahl >= 1 (gerundet wie Liquid round), sonst 0
  function ganz(x) {
    var n = Math.round(Number(x));
    return isFinite(n) && n >= 1 ? n : 0;
  }

  function nurZiffern(x) {
    var t = text(x);
    return /^[1-9][0-9]*$/.test(t) ? t : '';
  }

  function ersetze(vorlage, werte) {
    return vorlage.replace(/\{(\w+)\}/g, function (_, k) { return werte[k] === undefined ? '' : String(werte[k]); });
  }

  // 1518 -> "1.518" (Tausenderpunkt wie in der Sortimentsmatrix)
  function zahlText(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /**
   * Eintrag des Datenblocks (bzw. Felder eines Pfeils) -> Modell oder null. Gueltig nur mit Klasse A bis G und einem Ziel
   * (Label, sonst EPREL-Seite); { rueckfall: true } bleibt erhalten (Rueckfalltext der Kaufbox).
   */
  function normalisiere(roh) {
    if (!roh || typeof roh !== 'object') return null;
    var klasse = klasseVon(roh.klasse);
    var eprel = nurZiffern(roh.eprel);
    var label = text(roh.label);
    var ziel = text(roh.ziel) || label || (eprel ? EPREL_SEITE + eprel : '');
    if (!klasse || !ziel) return roh.rueckfall === true ? { rueckfall: true } : null;
    var breite = ganz(roh.breite);
    var hoehe = ganz(roh.hoehe);
    return {
      klasse: klasse,
      ziel: ziel,
      kwh: ganz(roh.kwh),
      kategorie: ganz(roh.kategorie) <= 6 ? ganz(roh.kategorie) : 0,
      eprel: eprel,
      label: label,
      breite: breite && hoehe ? breite : 0,
      hoehe: breite && hoehe ? hoehe : 0,
      datenblatt: text(roh.datenblatt) || (eprel ? EPREL_SEITE + eprel : ''),
      titel: text(roh.titel)
    };
  }

  function gueltig(d) {
    return !!(d && d.klasse && d.ziel);
  }

  /** Pfeil wie snippets/mv-energielabel.liquid (mv_el_pfeil); optionen.text = Buchstabe in Textgroesse. */
  function pfeilHtml(d, optionen) {
    if (!gueltig(d)) return '';
    var o = optionen || {};
    var k = d.klasse;
    var a = '<a class="mv-energie-pfeil mv-energie-pfeil--' + k.toLowerCase() + (o.text ? ' mv-energie-pfeil--text' : '') + '"' +
      ' href="' + maskiere(d.ziel) + '" target="_blank" rel="noopener"' +
      ' aria-label="' + maskiere(ersetze(TEXTE.pfeilAria, { klasse: k })) + '"' +
      ' data-mv-energie-pfeil data-mv-energie-klasse="' + k + '"' +
      (d.kwh ? ' data-mv-energie-kwh="' + d.kwh + '"' : '') +
      (d.kategorie ? ' data-mv-energie-kategorie="' + d.kategorie + '"' : '') +
      (d.eprel ? ' data-mv-energie-eprel="' + d.eprel + '"' : '') +
      (d.label ? ' data-mv-energie-label="' + maskiere(d.label) + '"' + (d.breite && d.hoehe ? ' data-mv-energie-breite="' + d.breite + '" data-mv-energie-hoehe="' + d.hoehe + '"' : '') : '') +
      (d.datenblatt ? ' data-mv-energie-datenblatt="' + maskiere(d.datenblatt) + '"' : '') +
      ' data-mv-energie-titel="' + maskiere(d.titel) + '">';
    return a +
      '<span class="mv-energie-pfeil__skala" aria-hidden="true"><span class="mv-energie-pfeil__a">A</span><span class="mv-energie-pfeil__bis">' + STRICH + '</span><span class="mv-energie-pfeil__g">G</span></span>' +
      '<span class="mv-energie-pfeil__klasse" aria-hidden="true"><span class="mv-energie-pfeil__form"><span class="mv-energie-pfeil__buchstabe">' + k + '</span></span></span></a>';
  }

  /** Link "Produktdatenblatt" wie snippets/mv-energielabel.liquid (mv_el_link). */
  function linkHtml(d) {
    if (!gueltig(d) || !d.datenblatt) return '';
    return '<a class="mv-link mv-energielabel__datenblatt" href="' + maskiere(d.datenblatt) + '" target="_blank" rel="noopener">' +
      maskiere(TEXTE.datenblatt) + '<span class="mv-visually-hidden">: ' + maskiere(d.titel) + '</span></a>';
  }

  /** Karte (Teil karte): Pfeil und Link oder nichts. */
  function karteHtml(d) {
    if (!gueltig(d)) return '';
    return '<span class="mv-energielabel mv-energielabel--karte">' + pfeilHtml(d) + linkHtml(d) + '</span>';
  }

  /** Inhalt der Zeile unter dem Kaufbox-Preis (Teil kaufbox, Slot info): Link, Rueckfalltext oder nichts. */
  function infoHtml(d) {
    if (gueltig(d)) return linkHtml(d);
    if (d && d.rueckfall === true) return '<p class="mv-hinweis mv-energielabel__hinweis">' + maskiere(TEXTE.rueckfall) + '</p>';
    return '';
  }

  /** "Energieeffizienzklasse C - Energieverbrauch 798 kWh/Jahr (Kategorie 3)", Trenner Mittelpunkt (Lightbox; Zahlen nur aus den Daten). */
  function werteText(d) {
    if (!gueltig(d)) return '';
    var t = ersetze(TEXTE.klasse, { klasse: d.klasse });
    if (d.kwh) t += PUNKT + ersetze(TEXTE.verbrauch, { kwh: zahlText(d.kwh) });
    if (d.kategorie) t += ' ' + ersetze(TEXTE.kategorie, { kategorie: d.kategorie });
    return t;
  }

  /** Alternativtext des Label-Bilds: Klasse und (falls vorhanden) Verbrauch. */
  function altText(d) {
    if (!gueltig(d)) return '';
    var t = ersetze(TEXTE.alt, { titel: d.titel, klasse: d.klasse }).replace(/ +:/, ':');
    if (d.kwh) t += ersetze(TEXTE.altVerbrauch, { kwh: zahlText(d.kwh) });
    return t;
  }

  /** Datenblock (JSON-Text) -> { varianten: { id: roh } } (leer bei Fehler). */
  function leseDaten(quelle) {
    try {
      var roh = JSON.parse(quelle);
      return roh && typeof roh === 'object' && roh.varianten && typeof roh.varianten === 'object' ? roh : { varianten: {} };
    } catch (e) {
      return { varianten: {} };
    }
  }

  function eintragFuer(daten, variantId) {
    if (!daten || variantId === null || variantId === undefined || variantId === '') return null;
    return normalisiere((daten.varianten || {})[String(variantId)]);
  }

  var logik = {
    VERSION: VERSION,
    TEXTE: TEXTE,
    EPREL_SEITE: EPREL_SEITE,
    maskiere: maskiere,
    klasseVon: klasseVon,
    zahlText: zahlText,
    normalisiere: normalisiere,
    pfeilHtml: pfeilHtml,
    linkHtml: linkHtml,
    karteHtml: karteHtml,
    infoHtml: infoHtml,
    werteText: werteText,
    altText: altText,
    leseDaten: leseDaten,
    eintragFuer: eintragFuer
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Modul mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.energielabel) return;

  var FOKUSSIERBAR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var dlg = null;
  var teile = null;
  var vorher = null;
  var offen = false;
  var cache = {};

  function attr(name, wert) {
    return '[' + name + '="' + String(wert).replace(/["\\]/g, '\\$&') + '"]';
  }

  function ausElement(el) {
    if (!el || !el.getAttribute) return null;
    var g = function (n) { return el.getAttribute('data-mv-energie-' + n); };
    return normalisiere({
      klasse: g('klasse'), ziel: el.getAttribute('href'), kwh: g('kwh'), kategorie: g('kategorie'), eprel: g('eprel'),
      label: g('label'), breite: g('breite'), hoehe: g('hoehe'), datenblatt: g('datenblatt'), titel: g('titel')
    });
  }

  function element(art, klasse, inhalt) {
    var el = document.createElement(art);
    if (klasse) el.className = klasse;
    if (inhalt) el.textContent = inhalt;
    return el;
  }

  function link(href, inhalt, klasse) {
    var a = element('a', klasse, inhalt);
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    return a;
  }

  function dialogBereit() {
    if (dlg && dlg.ownerDocument === document && document.documentElement.contains(dlg)) return dlg;
    var d = document.createElement('dialog');
    d.className = 'mv-energielabel-dialog';
    d.setAttribute('aria-labelledby', 'mv-energielabel-dialog-titel');
    d.setAttribute('data-mv-energielabel-dialog', '');
    var innen = element('div', 'mv-energielabel-dialog__inhalt');
    var kopf = element('div', 'mv-energielabel-dialog__kopf');
    var titel = element('h2', 'mv-energielabel-dialog__titel', TEXTE.dialogTitel);
    titel.id = 'mv-energielabel-dialog-titel';
    titel.setAttribute('tabindex', '-1');
    var zu = element('button', 'mv-button mv-button--secondary mv-energielabel-dialog__zu', TEXTE.schliessen);
    zu.type = 'button';
    zu.setAttribute('data-mv-energielabel-zu', '');
    kopf.appendChild(titel);
    kopf.appendChild(zu);
    var produkt = element('p', 'mv-energielabel-dialog__produkt');
    var rahmen = element('div', 'mv-energielabel-dialog__bildrahmen');
    var bild = element('img', 'mv-energielabel-dialog__bild');
    bild.setAttribute('alt', '');
    bild.setAttribute('decoding', 'async');
    rahmen.appendChild(bild);
    var werte = element('p', 'mv-energielabel-dialog__werte');
    var links = element('p', 'mv-energielabel-dialog__links');
    var quelle = element('p', 'mv-fussnote mv-energielabel-dialog__quelle');
    innen.appendChild(kopf);
    innen.appendChild(produkt);
    innen.appendChild(rahmen);
    innen.appendChild(werte);
    innen.appendChild(links);
    innen.appendChild(quelle);
    d.appendChild(innen);
    // close kommt als eigene Aufgabe nach dem Schliessen: ist der Dialog inzwischen wieder offen, gehoert es zum alten
    d.addEventListener('close', function () {
      if (!d.hasAttribute('open')) zu_(true);
    });
    d.addEventListener('cancel', function (e) {
      e.preventDefault();
      schliessen();
    });
    document.body.appendChild(d);
    dlg = d;
    teile = { titel: titel, produkt: produkt, bild: bild, werte: werte, links: links, quelle: quelle, zu: zu };
    return d;
  }

  function fuelle(d) {
    teile.produkt.textContent = d.titel;
    teile.produkt.hidden = !d.titel;
    teile.bild.setAttribute('src', d.label);
    teile.bild.setAttribute('alt', altText(d));
    if (d.breite && d.hoehe) {
      teile.bild.setAttribute('width', String(d.breite));
      teile.bild.setAttribute('height', String(d.hoehe));
    } else {
      teile.bild.removeAttribute('width');
      teile.bild.removeAttribute('height');
    }
    teile.werte.textContent = werteText(d);
    teile.links.textContent = '';
    if (d.datenblatt) teile.links.appendChild(link(d.datenblatt, TEXTE.datenblatt, 'mv-link mv-energielabel-dialog__link'));
    teile.links.appendChild(link(d.label, TEXTE.labelTab, 'mv-link mv-energielabel-dialog__link'));
    teile.quelle.textContent = TEXTE.quelle;
    if (d.eprel) {
      teile.quelle.appendChild(document.createTextNode(' '));
      teile.quelle.appendChild(link(EPREL_SEITE + d.eprel, TEXTE.eprelLink, 'mv-energielabel-dialog__eprel'));
    }
  }

  /** Oeffnet die Lightbox fuer einen Pfeil (true) oder laesst den Link wirken (false: kein Label-Bild). */
  function oeffnen(el) {
    var d = ausElement(el);
    if (!d || !d.label) return false;
    dialogBereit();
    fuelle(d);
    vorher = el;
    offen = true;
    var nativ = false;
    if (typeof dlg.showModal === 'function') {
      try {
        if (!dlg.open) dlg.showModal();
        nativ = true;
      } catch (e) {
        nativ = false;
      }
    }
    if (!nativ) {
      dlg.setAttribute('open', '');
      dlg.classList.add('mv-energielabel-dialog--ersatz');
      dlg.setAttribute('aria-modal', 'true');
    }
    teile.titel.focus();
    return true;
  }

  // Abschluss: Fokus zurueck auf den Pfeil (oder, nach Austausch durch Impact, auf einen gleichen Pfeil)
  function zu_(ausClose) {
    if (!offen && !ausClose) return;
    offen = false;
    if (dlg) {
      dlg.classList.remove('mv-energielabel-dialog--ersatz');
      dlg.removeAttribute('aria-modal');
    }
    var ziel = vorher;
    vorher = null;
    if (ziel && document.documentElement.contains(ziel) && typeof ziel.focus === 'function') ziel.focus();
  }

  function schliessen() {
    if (!dlg) return false;
    var war = offen;
    if (dlg.hasAttribute('open')) {
      if (typeof dlg.close === 'function' && !dlg.classList.contains('mv-energielabel-dialog--ersatz')) {
        try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
      } else {
        dlg.removeAttribute('open');
      }
    }
    if (war) zu_(false);
    return war;
  }

  function fokussierbare() {
    var liste = dlg ? dlg.querySelectorAll(FOKUSSIERBAR) : [];
    var out = [];
    for (var i = 0; i < liste.length; i++) if (!liste[i].closest('[hidden]')) out.push(liste[i]);
    return out;
  }

  // Ersatzebene ohne showModal: Escape schliesst, Tab bleibt im Dialog
  function taste(e) {
    if (!offen || !dlg || !e) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      schliessen();
      return;
    }
    if (e.key !== 'Tab' || !dlg.classList.contains('mv-energielabel-dialog--ersatz')) return;
    var liste = fokussierbare();
    if (!liste.length) return;
    var aktiv = document.activeElement;
    var erstes = liste[0];
    var letztes = liste[liste.length - 1];
    if (!dlg.contains(aktiv)) {
      e.preventDefault();
      erstes.focus();
    } else if (e.shiftKey && (aktiv === erstes || aktiv === teile.titel)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && aktiv === letztes) {
      e.preventDefault();
      erstes.focus();
    }
  }

  function klick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (dlg && offen) {
      if (t.closest('[data-mv-energielabel-zu]')) {
        e.preventDefault();
        schliessen();
        return;
      }
      if (t === dlg) { // Flaeche ausserhalb des Inhalts (Hintergrund)
        schliessen();
        return;
      }
    }
    var pfeil = t.closest('[data-mv-energie-pfeil]');
    if (!pfeil || e.defaultPrevented) return;
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // neuer Tab wie gewuenscht
    if (!pfeil.getAttribute('data-mv-energie-label')) return; // nur EPREL-Seite: der Link oeffnet sie im neuen Tab
    e.preventDefault();
    oeffnen(pfeil);
  }

  // ---- Variantenwechsel -------------------------------------------------------------------------

  function datenVon(formId) {
    var s = document.querySelector('script' + attr('data-mv-energielabel-daten', formId));
    if (!s) return null;
    var q = s.textContent || '';
    if (!cache[formId] || cache[formId].quelle !== q) cache[formId] = { quelle: q, daten: leseDaten(q) };
    return cache[formId].daten;
  }

  /** Fuellt alle Slots des Formulars fuer die Variante (null = keine Variante); Rueckgabe: Anzahl geaenderter Slots. */
  function aktualisiere(formId, variantId) {
    if (!formId) return 0;
    var daten = datenVon(formId);
    if (!daten) return 0;
    var id = variantId === null || variantId === undefined ? '' : String(variantId);
    var eintrag = eintragFuer(daten, id);
    var slots = document.querySelectorAll('[data-mv-energie-slot]' + attr('data-mv-energie-form', formId));
    var n = 0;
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      if (slot.getAttribute('data-mv-energie-variante') === id) continue;
      var art = slot.getAttribute('data-mv-energie-slot');
      var html = art === 'pfeil'
        ? pfeilHtml(eintrag, { text: slot.getAttribute('data-mv-energie-groesse') === 'text' })
        : art === 'info' ? infoHtml(eintrag) : '';
      slot.innerHTML = html;
      slot.setAttribute('data-mv-energie-variante', id);
      n++;
    }
    return n;
  }

  /** Karte als Knoten (Finder: Datenblock-Eintrag -> DocumentFragment mit Pfeil und Link, sonst null). */
  function karteKnoten(roh, doc) {
    var html = karteHtml(normalisiere(roh));
    if (!html) return null;
    var t = (doc || document).createElement('template');
    t.innerHTML = html;
    return t.content;
  }

  var GRUENDE = { variante: 1, rerender: 1, konto: 1 };

  document.addEventListener('click', klick);
  document.addEventListener('keydown', taste);

  // Konfigurator (assets/mv-sortiment.konfigurator.js): nach jedem Variantenwechsel, Austausch und Konto-Stand
  document.addEventListener('mv:konf:change', function (e) {
    var d = (e && e.detail) || {};
    if (!GRUENDE[d.grund] || !d.formId) return;
    var z = d.state || {};
    aktualisiere(d.formId, z.variantId === undefined ? null : z.variantId);
  });

  // Impact: variant:change am Formular (detail.variant null = Kombination ohne Variante)
  document.addEventListener('variant:change', function (e) {
    var form = e && e.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!formId) return;
    var d = (e && e.detail) || {};
    if (!Object.prototype.hasOwnProperty.call(d, 'variant')) return;
    aktualisiere(formId, d.variant && d.variant.id ? d.variant.id : null);
  });

  MV.energielabel = {
    version: VERSION,
    logik: logik,
    karteHtml: karteHtml,
    karteKnoten: karteKnoten,
    pfeilHtml: pfeilHtml,
    oeffnen: oeffnen,
    schliessen: schliessen,
    aktualisieren: aktualisiere
  };
})();

;

/* ==== Teil: assets/mv-sortiment.m4.js ==== */
/* MV Sortiment assets/mv-sortiment.m4.js - Paket M-4 - 2026-10-12
 *
 * Mobil-Optimierungsrunde, Inhaber 12.10.2026: "Mach mal eine mobile Optimierungsrunde fuer den MV Vending Shop,
 * einiges wird noch nicht so geil angezeigt." Paket M-4 "Wischbereiche, Tabellen, Typografie, Fuss". Teil von
 * assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge mit den anderen Teilen. Kein
 * Inline-Skript, kein Speicher; Listener nur auf document (scroll und toggle in der Capture-Phase, scroll passiv;
 * shopify:section:load, DOMContentLoaded) und window (resize, pageshow) sowie die Medienabfragen MOBIL und SCHMAL;
 * dazu ein ResizeObserver auf den gefundenen Bereichen. Waechter window.__mvSortimentM4. Stile:
 * assets/mv-sortiment.m4.css. Doku _docs/m4-mobil.md, Tests _tests/m4-mobil.test.mjs.
 *
 * 1. Wisch-Verlauf: Unter 1000 px (MOBIL) sucht die Datei beim Start, nach shopify:section:load und beim Wechsel
 *    ueber 700/1000 px alle Elemente mit overflow-x auto|scroll innerhalb von [class*="mv-"] (ausgenommen das mobile
 *    Menue .mv-mm, Impacts Produktgalerie und die Drawer). Laeuft ein Bereich ueber (scrollWidth > clientWidth + 2),
 *    setzt sie data-mv-m4-wisch="rechts|links|beide" nach der Seite mit verdecktem Inhalt und haelt den Wert beim
 *    Scrollen, bei Groessenaenderung und beim Aufklappen (details, toggle) aktuell. Klebt die erste Spalte einer
 *    Tabelle (mv-tabelle), steht ihre Breite in --mvs-m4-fest (Verlauf links beginnt dahinter). Liegt das letzte
 *    Element einer flex-Reihe weniger als 12 px vor dem Ende, setzt sie data-mv-m4-ende="flex" (::after als Abstand)
 *    bzw. "polster" (Reihe hat schon ein ::after: padding-inline-end) und rechnet den gemessenen Zuwachs der
 *    Scrollbreite heraus, damit der Abstand allein nie als Ueberlauf zaehlt. Raster bekommen keinen Abstand (Chrome
 *    zaehlt padding-inline-end eines Rasters nicht zur Scrollflaeche, ein ::after waere eine ganze Spalte).
 * 2. Hinweis: Vor einer ueberlaufenden Tabellen-Huelle (.mv-tabelle, .mv-aushang-tabelle) oder Tabelle aus Punkt 3
 *    steht <p class="mv-m4-wischen" aria-hidden="true"> mit Icon "breite" (wie snippets/mv-icon) und "Seitlich
 *    wischen fuer alle Spalten" - nicht, wenn ein Geschwister schon einen Hinweis traegt (Klasse auf __wischen oder
 *    -wischen: Spiralen, Finanzierungsvergleich, snack-roi, Teile, Standort, Businessplan). Faellt der Ueberlauf weg
 *    oder gilt MOBIL nicht mehr, entfernt die Datei den Hinweis wieder.
 * 3. Tabelle in .prose ohne Scrollbereich (X10-Produktbeschreibung): Ist sie breiter als der Inhalt ihres Elternteils,
 *    bekommt sie data-mv-m4-tabelle (die CSS macht sie zum Scrollbereich) und die ARIA-Tabellenrollen; passt ihr
 *    Inhalt wieder, fallen Marke und Rollen weg. Sie wird nie gestapelt.
 * 4. Stapeln (nur unter 700 px, SCHMAL): .mv-hilfe-tabelle, .mv-aushang-tabelle und .mv-wissen-tabelle sowie
 *    weitere .mv-tabelle mit hoechstens 4 Spalten und im Mittel mehr als 24 Zeichen je Zelle (ausgenommen --vergleich,
 *    --technik, Linienvergleich, Finanzierungsvergleich, Spiralen-Vergleich) bekommen data-mv-m4-stapel an der
 *    Huelle, data-label je Wertzelle aus dem passenden Kopf (sichtbarer Text, colspan beachtet) und die
 *    ARIA-Tabellenrollen. Ohne Kopf mit mindestens zwei Zellen wird nicht gestapelt. Wert der Marke "kompakt", wenn
 *    jede Karte mindestens zwei Wertzellen hat und keine mehr als 40 Zeichen (Wertzellen zweispaltig), sonst leer.
 *    Ab 700 px nimmt die Datei genau die Attribute wieder weg, die sie gesetzt hat.
 * Ab 1000 px laesst die Datei das DOM wie vorher: keine Hinweise, Marken, Rollen oder Labels.
 *
 * Der sichtbare Text setzt den Umlaut per String.fromCharCode zusammen: die Datei bleibt reines ASCII. Unter Node
 * (Tests) liefert sie nur die reinen Funktionen ueber module.exports.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-12.2';
  // Gleiche Grenzen wie die Medienabfragen in assets/mv-sortiment.m4.css
  var MOBIL = 'screen and (max-width: 999.98px)';
  var SCHMAL = 'screen and (max-width: 699.98px)';
  var BEREICH = '[class*="mv-"]';
  var AUSNAHMEN = '.mv-mm, navigation-drawer, cart-drawer, search-drawer, product-gallery, media-carousel, .product-gallery';
  var TABELLEN_HUELLE = '.mv-tabelle, .mv-aushang-tabelle';
  var SCHWELLE = 2;
  var ENDE_MIN = 12;
  var STAPEL_KLASSEN = ['mv-hilfe-tabelle', 'mv-aushang-tabelle', 'mv-wissen-tabelle'];
  var STAPEL_AUSNAHMEN = ['mv-tabelle--vergleich', 'mv-tabelle--technik', 'mv-linienvergleich__rahmen', 'mv-finv-tabelle', 'mv-spiralen-vergleich'];
  var STAPEL_MAX_SPALTEN = 4;
  var STAPEL_MIN_ZEICHEN = 24;
  var STAPEL_KOMPAKT_ZEICHEN = 40;
  var VERSTECKT = '.mv-visually-hidden, .sr-only, .visually-hidden';
  // "Seitlich wischen fuer alle Spalten" mit u-Umlaut (Zeichen 252), die Datei bleibt ASCII
  var HINWEIS_TEXT = 'Seitlich wischen f' + String.fromCharCode(252) + 'r alle Spalten';
  // Icon "breite" aus snippets/mv-icon.liquid
  var ICON_PFAD = 'M3 5v14M21 5v14M4.5 12h15M7.5 9l-3 3 3 3M16.5 9l3 3-3 3';

  // ===========================================================================================
  // Reine Logik (ohne window und document; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function zahl(x) {
    var n = parseFloat(x);
    return isFinite(n) ? n : 0;
  }

  function text(x) {
    return x === null || x === undefined ? '' : String(x).replace(/\s+/g, ' ').trim();
  }

  // Seite(n) mit verdecktem Inhalt: links = schon gescrollt, rechts = Rest. Bis SCHWELLE px zaehlt nichts.
  function wischZustand(links, breite, sichtbar) {
    var max = zahl(breite) - zahl(sichtbar);
    if (max <= SCHWELLE) return '';
    var l = Math.max(0, zahl(links));
    var vorne = l > SCHWELLE;
    var hinten = max - l > SCHWELLE;
    if (vorne && hinten) return 'beide';
    if (hinten) return 'rechts';
    if (vorne) return 'links';
    return '';
  }

  // Mittlere Zeichenzahl je Zelle (Leerraum zusammengefasst)
  function mittelZeichen(texte) {
    var liste = texte || [];
    if (!liste.length) return 0;
    var summe = 0;
    for (var i = 0; i < liste.length; i++) summe += text(liste[i]).length;
    return summe / liste.length;
  }

  // o: { benannt, ausgenommen, kopfZellen, spalten, zeichen }
  function stapelEntscheid(o) {
    if (!o || o.ausgenommen) return false;
    if (zahl(o.kopfZellen) < 2) return false;
    if (o.benannt) return true;
    return zahl(o.spalten) > 0 && zahl(o.spalten) <= STAPEL_MAX_SPALTEN && zahl(o.zeichen) > STAPEL_MIN_ZEICHEN;
  }

  // Wert der Marke data-mv-m4-stapel: "kompakt" (Wertzellen der Karte zweispaltig), wenn jede Karte mindestens zwei
  // Wertzellen hat und keine laenger als STAPEL_KOMPAKT_ZEICHEN ist; sonst "" (eine Spalte).
  // o: { werte: [Text der Wertzellen aller Zeilen], jeZeile: kleinste Zahl der Wertzellen einer Zeile }
  function stapelArt(o) {
    var liste = (o && o.werte) || [];
    if (!liste.length || zahl(o.jeZeile) < 2) return '';
    for (var i = 0; i < liste.length; i++) if (text(liste[i]).length > STAPEL_KOMPAKT_ZEICHEN) return '';
    return 'kompakt';
  }

  // Label je Zelle einer Zeile aus dem Kopf; kopf: [{ text, spanne }], zeile: [spanne]; Label der ersten Spalte, die
  // eine Zelle beruehrt
  function spaltenLabels(kopf, zeile) {
    var spalten = [];
    (kopf || []).forEach(function (k) {
      var n = Math.max(1, Math.floor(zahl(k && k.spanne) || 1));
      for (var i = 0; i < n; i++) spalten.push(text(k && k.text));
    });
    var labels = [];
    var pos = 0;
    (zeile || []).forEach(function (s) {
      labels.push(pos < spalten.length ? spalten[pos] : '');
      pos += Math.max(1, Math.floor(zahl(s) || 1));
    });
    return labels;
  }

  // Art des Abstands am Ende: nur einzeilige flex-Reihen (o = { display, richtung, umbruch, hatNach })
  function endeArt(o) {
    if (!o) return '';
    var d = String(o.display || '');
    if (d !== 'flex' && d !== 'inline-flex') return '';
    if ((String(o.richtung || '') || 'row') !== 'row' || (String(o.umbruch || '') || 'nowrap') !== 'nowrap') return '';
    return o.hatNach ? 'polster' : 'flex';
  }

  // Klasse eines vorhandenen Hinweises: ...__wischen oder ...-wischen (mv-bp-wischen, mv-m4-wischen)
  function istHinweisKlasse(k) {
    return /(?:__|-)wischen$/.test(String(k || ''));
  }

  var logik = {
    VERSION: VERSION,
    MOBIL: MOBIL,
    SCHMAL: SCHMAL,
    BEREICH: BEREICH,
    AUSNAHMEN: AUSNAHMEN,
    TABELLEN_HUELLE: TABELLEN_HUELLE,
    SCHWELLE: SCHWELLE,
    ENDE_MIN: ENDE_MIN,
    STAPEL_KLASSEN: STAPEL_KLASSEN,
    STAPEL_AUSNAHMEN: STAPEL_AUSNAHMEN,
    STAPEL_MAX_SPALTEN: STAPEL_MAX_SPALTEN,
    STAPEL_MIN_ZEICHEN: STAPEL_MIN_ZEICHEN,
    STAPEL_KOMPAKT_ZEICHEN: STAPEL_KOMPAKT_ZEICHEN,
    HINWEIS_TEXT: HINWEIS_TEXT,
    ICON_PFAD: ICON_PFAD,
    wischZustand: wischZustand,
    mittelZeichen: mittelZeichen,
    stapelEntscheid: stapelEntscheid,
    stapelArt: stapelArt,
    spaltenLabels: spaltenLabels,
    endeArt: endeArt,
    istHinweisKlasse: istHinweisKlasse
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Skript mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  if (window.__mvSortimentM4) return;
  var api = window.__mvSortimentM4 = { version: VERSION, logik: logik };
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (!MV.m4) MV.m4 = api;

  var SVG = 'http://www.w3.org/2000/svg';
  var HTML = 'http://www.w3.org/1999/xhtml';
  var mqMobil = typeof window.matchMedia === 'function' ? window.matchMedia(MOBIL) : null;
  var mqSchmal = typeof window.matchMedia === 'function' ? window.matchMedia(SCHMAL) : null;
  // Scrollbereich -> Zustand { art: 'scroll'|'prosa', ende, zuwachs, endeGeprueft, hinweis, rollen }
  var kandidaten = new Map();
  // gestapelte Huelle -> Liste [Element, Attribut] der Attribute, die diese Datei gesetzt hat
  var gestapelt = new Map();
  // Huelle -> Ergebnis der Pruefung (Inhalt ist statisch)
  var analysen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var geplant = new Set();
  var planTimer = 0;
  var ro = typeof window.ResizeObserver === 'function' ? new window.ResizeObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) planen(eintraege[i].target);
  }) : null;

  // Ohne Medienabfrage gilt Desktop: nichts aendern (sicherer Rueckfall)
  function mobil() {
    return !!(mqMobil && mqMobil.matches);
  }

  function schmal() {
    return !!(mqSchmal && mqSchmal.matches);
  }

  function alsListe(x) {
    return Array.prototype.slice.call(x || []);
  }

  function stil(el, pseudo) {
    try {
      return window.getComputedStyle(el, pseudo || null);
    } catch (e) {
      return null;
    }
  }

  function istScrollWert(w) {
    return w === 'auto' || w === 'scroll';
  }

  // Tabelle als direktes Kind (Huelle .mv-tabelle, .mv-aushang-tabelle, Linienvergleich ...)
  function kindTabelle(el) {
    var kinder = el.children || [];
    for (var i = 0; i < kinder.length; i++) if (kinder[i].tagName === 'TABLE') return kinder[i];
    return null;
  }

  // Hinweis nur an Tabellen-Huellen und an Tabellen aus Punkt 3
  function istHinweisBereich(el) {
    return el.hasAttribute('data-mv-m4-tabelle') || (typeof el.matches === 'function' && el.matches(TABELLEN_HUELLE) && !!kindTabelle(el));
  }

  // Tabelle in .prose ohne eigenen Scrollbereich dazwischen (nicht in mv-tabelle)
  function istProsaTabelle(el) {
    if (el.tagName !== 'TABLE' || typeof el.closest !== 'function') return false;
    var prosa = el.closest('.prose');
    if (!prosa || el.closest('.mv-tabelle')) return false;
    for (var a = el.parentElement; a && a !== prosa; a = a.parentElement) {
      var s = stil(a);
      if (s && istScrollWert(s.overflowX)) return false;
    }
    return true;
  }

  // Attribut nur setzen, wenn es fehlt, und merken (damit nur eigene Attribute wieder wegfallen)
  function attributSetzen(liste, el, name, wert) {
    if (el.hasAttribute(name)) return;
    el.setAttribute(name, wert);
    liste.push([el, name]);
  }

  function attributeEntfernen(liste) {
    (liste || []).forEach(function (p) {
      p[0].removeAttribute(p[1]);
    });
  }

  // ARIA-Rollen: Tabellensemantik bleibt erhalten, wenn die CSS display aendert
  function rollenSetzen(tabelle, liste) {
    attributSetzen(liste, tabelle, 'role', 'table');
    alsListe(tabelle.children).forEach(function (gruppe) {
      if (/^(THEAD|TBODY|TFOOT)$/.test(gruppe.tagName)) attributSetzen(liste, gruppe, 'role', 'rowgroup');
    });
    alsListe(tabelle.rows).forEach(function (zeile) {
      attributSetzen(liste, zeile, 'role', 'row');
      var imKopf = zeile.parentElement && zeile.parentElement.tagName === 'THEAD';
      alsListe(zeile.cells).forEach(function (zelle) {
        var rolle = 'cell';
        if (zelle.tagName === 'TH') rolle = imKopf || zelle.getAttribute('scope') === 'col' ? 'columnheader' : 'rowheader';
        attributSetzen(liste, zelle, 'role', rolle);
      });
    });
  }

  // ---------------------------------------------------------------------------------------------
  // Stapeln (nur unter 700 px)
  // ---------------------------------------------------------------------------------------------

  function sichtbarerText(zelle) {
    var kopie = zelle.cloneNode(true);
    alsListe(kopie.querySelectorAll(VERSTECKT)).forEach(function (x) {
      if (x.parentNode) x.parentNode.removeChild(x);
    });
    return text(kopie.textContent);
  }

  function analyse(huelle) {
    var vorhanden = analysen && analysen.get(huelle);
    if (vorhanden) return vorhanden;
    var tabelle = kindTabelle(huelle);
    var ergebnis = { ja: false, art: '', tabelle: tabelle, labels: [] };
    if (tabelle) {
      var kopfZeilen = tabelle.tHead ? tabelle.tHead.rows : [];
      var kopfZeile = kopfZeilen.length ? kopfZeilen[kopfZeilen.length - 1] : null;
      var kopf = kopfZeile ? alsListe(kopfZeile.cells).map(function (c) {
        return { text: sichtbarerText(c), spanne: c.colSpan || 1 };
      }) : [];
      var zeilen = [];
      alsListe(tabelle.tBodies).forEach(function (b) {
        zeilen = zeilen.concat(alsListe(b.rows));
      });
      var spalten = kopf.reduce(function (s, k) { return s + k.spanne; }, 0);
      var texte = [];
      var werte = [];
      var jeZeile = zeilen.length ? Infinity : 0;
      zeilen.forEach(function (z) {
        var zellen = alsListe(z.cells);
        var labels = spaltenLabels(kopf, zellen.map(function (c) { return c.colSpan || 1; }));
        var n = 0;
        zellen.forEach(function (c, i) {
          n += c.colSpan || 1;
          texte.push(c.textContent);
          if (i === 0) return;
          werte.push(c.textContent);
          if (labels[i]) ergebnis.labels.push([c, labels[i]]);
        });
        spalten = Math.max(spalten, n);
        jeZeile = Math.min(jeZeile, zellen.length - 1);
      });
      var klassen = huelle.classList;
      ergebnis.ja = stapelEntscheid({
        benannt: STAPEL_KLASSEN.some(function (k) { return klassen.contains(k); }),
        ausgenommen: STAPEL_AUSNAHMEN.some(function (k) { return !!huelle.closest('.' + k); }),
        kopfZellen: kopf.length,
        spalten: spalten,
        zeichen: mittelZeichen(texte)
      });
      ergebnis.art = stapelArt({ werte: werte, jeZeile: jeZeile });
    }
    if (analysen) analysen.set(huelle, ergebnis);
    return ergebnis;
  }

  function stapelAn(huelle) {
    if (gestapelt.has(huelle)) return;
    var a = analyse(huelle);
    if (!a.ja) return;
    var liste = [];
    rollenSetzen(a.tabelle, liste);
    a.labels.forEach(function (p) {
      attributSetzen(liste, p[0], 'data-label', p[1]);
    });
    attributSetzen(liste, huelle, 'data-mv-m4-stapel', a.art);
    gestapelt.set(huelle, liste);
  }

  function stapelAus(huelle) {
    attributeEntfernen(gestapelt.get(huelle));
    gestapelt.delete(huelle);
  }

  function stapelSuchen(bereich) {
    gestapelt.forEach(function (liste, huelle) {
      if (!huelle.isConnected) gestapelt.delete(huelle);
      else if (!schmal()) stapelAus(huelle);
    });
    if (!schmal()) return;
    var wurzel = bereich && typeof bereich.querySelectorAll === 'function' ? bereich : document;
    var liste = alsListe(wurzel.querySelectorAll(TABELLEN_HUELLE));
    if (wurzel.nodeType === 1 && typeof wurzel.matches === 'function' && wurzel.matches(TABELLEN_HUELLE)) liste.unshift(wurzel);
    liste.forEach(function (huelle) {
      if (!huelle.closest(AUSNAHMEN)) stapelAn(huelle);
    });
  }

  // ---------------------------------------------------------------------------------------------
  // Scrollbereiche: Suche, Hinweis, Zustand
  // ---------------------------------------------------------------------------------------------

  var UEBERSPRINGEN = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, IMG: 1, INPUT: 1, BR: 1, SOURCE: 1, PICTURE: 1, VIDEO: 1, IFRAME: 1, OPTION: 1 };

  function aufnehmen(el, art) {
    kandidaten.set(el, { art: art, ende: '', zuwachs: 0, endeGeprueft: false, hinweis: null, rollen: [] });
    if (ro) ro.observe(el);
  }

  function vergessen(el) {
    var z = kandidaten.get(el);
    if (z && z.hinweis && z.hinweis.parentNode) z.hinweis.parentNode.removeChild(z.hinweis);
    kandidaten.delete(el);
    if (ro) ro.unobserve(el);
  }

  // Kandidaten im Bereich (auch der Bereich selbst) aufnehmen
  function suchen(bereich) {
    var wurzel = bereich && typeof bereich.querySelectorAll === 'function' ? bereich : document;
    var liste = alsListe(wurzel.querySelectorAll(BEREICH + ', ' + BEREICH + ' *'));
    if (wurzel.nodeType === 1 && typeof wurzel.closest === 'function' && wurzel.closest(BEREICH)) liste.unshift(wurzel);
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      if (kandidaten.has(el) || el.namespaceURI !== HTML || UEBERSPRINGEN[el.tagName]) continue;
      if (el === document.documentElement || el === document.body) continue;
      if (el.closest(AUSNAHMEN)) continue;
      if (istProsaTabelle(el)) {
        aufnehmen(el, 'prosa');
        continue;
      }
      var s = stil(el);
      if (s && istScrollWert(s.overflowX)) aufnehmen(el, 'scroll');
    }
  }

  function hinweisErzeugen() {
    var p = document.createElement('p');
    p.className = 'mv-m4-wischen';
    p.setAttribute('aria-hidden', 'true');
    var svg = document.createElementNS(SVG, 'svg');
    var attribute = { 'class': 'mv-icon mv-m4-wischen__icon', width: '18', height: '18', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.75', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' };
    Object.keys(attribute).forEach(function (k) { svg.setAttribute(k, attribute[k]); });
    var pfad = document.createElementNS(SVG, 'path');
    pfad.setAttribute('d', ICON_PFAD);
    svg.appendChild(pfad);
    var span = document.createElement('span');
    span.textContent = HINWEIS_TEXT;
    p.appendChild(svg);
    p.appendChild(span);
    return p;
  }

  // Traegt ein anderes Geschwister schon einen Hinweis (eigener zaehlt nicht)?
  function hatHinweisNachbar(el, eigener) {
    var kinder = el.parentElement ? el.parentElement.children : [];
    for (var i = 0; i < kinder.length; i++) {
      var k = kinder[i];
      if (k === el || k === eigener) continue;
      if (alsListe(k.classList).some(istHinweisKlasse)) return true;
    }
    return false;
  }

  function hinweisEntfernen(z) {
    if (z.hinweis && z.hinweis.parentNode) z.hinweis.parentNode.removeChild(z.hinweis);
    z.hinweis = null;
  }

  function hinweisSichern(el, z) {
    if (z.hinweis && z.hinweis.parentNode === el.parentElement && z.hinweis.nextElementSibling === el) return;
    hinweisEntfernen(z);
    if (!el.parentElement || hatHinweisNachbar(el, null)) return;
    z.hinweis = hinweisErzeugen();
    el.parentElement.insertBefore(z.hinweis, el);
  }

  // Breite der klebenden ersten Spalte, sonst 0
  function festBreite(el) {
    var tabelle = el.tagName === 'TABLE' ? el : kindTabelle(el);
    var zeile = tabelle && tabelle.rows && tabelle.rows[0];
    var zelle = zeile && zeile.cells && zeile.cells[0];
    var s = zelle ? stil(zelle) : null;
    if (!s || s.position !== 'sticky') return 0;
    return Math.round(zelle.getBoundingClientRect().width);
  }

  function festSetzen(el, px) {
    var alt = el.style ? el.style.getPropertyValue('--mvs-m4-fest') : '';
    if (px > 0) {
      if (alt !== px + 'px') el.style.setProperty('--mvs-m4-fest', px + 'px');
    } else if (alt) {
      el.style.removeProperty('--mvs-m4-fest');
      if (!el.getAttribute('style')) el.removeAttribute('style');
    }
  }

  // Abstand vom letzten sichtbaren Kind bis zum Ende der Scrollflaeche (unabhaengig von der Scrollposition)
  function endeMessen(el) {
    var kinder = alsListe(el.children).filter(function (k) {
      var ks = stil(k);
      return !ks || ks.display !== 'none';
    });
    var letztes = kinder[kinder.length - 1];
    if (!letztes) return Infinity;
    var r = el.getBoundingClientRect();
    var ursprung = r.left + (el.clientLeft || 0) - el.scrollLeft;
    return el.scrollWidth - (letztes.getBoundingClientRect().right - ursprung);
  }

  function endeSetzen(el, z, s) {
    z.endeGeprueft = true;
    if (el.tagName === 'TABLE' || kindTabelle(el)) return;
    var art = endeArt({ display: s.display, richtung: s.flexDirection, umbruch: s.flexWrap, hatNach: false });
    if (!art || endeMessen(el) >= ENDE_MIN) return;
    var nach = stil(el, '::after');
    if (nach && nach.content && nach.content !== 'none' && nach.content !== 'normal') art = 'polster';
    var vorher = el.scrollWidth;
    el.setAttribute('data-mv-m4-ende', art);
    z.ende = art;
    z.zuwachs = Math.max(0, el.scrollWidth - vorher);
  }

  function endeEntfernen(el, z) {
    if (z.ende) el.removeAttribute('data-mv-m4-ende');
    z.ende = '';
    z.zuwachs = 0;
    z.endeGeprueft = false;
  }

  function prosaAus(el, z) {
    el.removeAttribute('data-mv-m4-tabelle');
    attributeEntfernen(z.rollen);
    z.rollen = [];
  }

  function zuruecksetzen(el, z) {
    if (el.hasAttribute('data-mv-m4-wisch')) el.removeAttribute('data-mv-m4-wisch');
    festSetzen(el, 0);
    endeEntfernen(el, z);
    hinweisEntfernen(z);
    if (z.art === 'prosa' && el.hasAttribute('data-mv-m4-tabelle')) prosaAus(el, z);
  }

  function inhaltsBreite(el) {
    var s = stil(el);
    return el.clientWidth - zahl(s && s.paddingLeft) - zahl(s && s.paddingRight);
  }

  // Tabelle in .prose: Marke setzen, wenn sie breiter ist als der Inhalt ihres Elternteils; entfernen, wenn ihr
  // Inhalt als Scrollbereich wieder hineinpasst
  function prosaPruefen(el, z) {
    if (el.hasAttribute('data-mv-m4-tabelle')) {
      if (el.scrollWidth <= el.clientWidth + SCHWELLE) prosaAus(el, z);
      return;
    }
    var platz = el.parentElement ? inhaltsBreite(el.parentElement) : 0;
    if (platz > 0 && el.getBoundingClientRect().width > platz + SCHWELLE) {
      z.rollen = [];
      rollenSetzen(el, z.rollen);
      el.setAttribute('data-mv-m4-tabelle', '');
    }
  }

  function pruefen(el) {
    var z = kandidaten.get(el);
    if (!z) return;
    if (!el.isConnected) {
      vergessen(el);
      return;
    }
    if (!mobil()) {
      zuruecksetzen(el, z);
      return;
    }
    if (z.art === 'prosa') prosaPruefen(el, z);
    var s = stil(el);
    var zustand = s && istScrollWert(s.overflowX) ? wischZustand(el.scrollLeft, el.scrollWidth - z.zuwachs, el.clientWidth) : '';
    if (!zustand) {
      zuruecksetzen(el, z);
      return;
    }
    if (el.getAttribute('data-mv-m4-wisch') !== zustand) el.setAttribute('data-mv-m4-wisch', zustand);
    if (!z.endeGeprueft) endeSetzen(el, z, s);
    if (el.tagName === 'TABLE' || kindTabelle(el)) festSetzen(el, festBreite(el));
    if (istHinweisBereich(el)) hinweisSichern(el, z);
    else hinweisEntfernen(z);
  }

  function abarbeiten() {
    planTimer = 0;
    var liste = Array.from(geplant);
    geplant.clear();
    liste.forEach(pruefen);
  }

  function planen(el) {
    if (!kandidaten.has(el)) return;
    geplant.add(el);
    if (planTimer) return;
    planTimer = typeof window.requestAnimationFrame === 'function' ? window.requestAnimationFrame(abarbeiten) : window.setTimeout(abarbeiten, 16);
  }

  function allePruefen() {
    Array.from(kandidaten.keys()).forEach(pruefen);
  }

  // Erst stapeln (aendert den Ueberlauf), dann Scrollbereiche suchen und pruefen
  function neu(bereich) {
    stapelSuchen(bereich || document);
    if (mobil()) suchen(bereich || document);
    allePruefen();
  }

  // Scroll-Ereignisse steigen nicht auf: Capture-Phase auf document, passiv
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.nodeType === 1) planen(e.target);
  }, { capture: true, passive: true });

  // details aufgeklappt: Bereiche darin neu messen (toggle steigt nicht auf)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.nodeType !== 1 || !d.open) return;
    kandidaten.forEach(function (z, el) {
      if (d.contains(el)) planen(el);
    });
  }, true);

  // Theme-Editor: neu geladene Sektion durchsuchen; entfernte Elemente fallen beim naechsten Pruefen heraus
  document.addEventListener('shopify:section:load', function (e) {
    neu(e.target);
  });

  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      resizeTimer = 0;
      allePruefen();
    }, 150);
  });

  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) allePruefen();
  });

  // Grenzen 1000 und 700 px: stapeln oder zurueckbauen; Bereiche koennen erst unterhalb scrollen (Chips der Kollektion)
  function wechsel() {
    neu(document);
  }
  [mqMobil, mqSchmal].forEach(function (mq) {
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', wechsel);
    else if (typeof mq.addListener === 'function') mq.addListener(wechsel);
  });

  api.neu = neu;
  api.pruefen = allePruefen;
  api.kandidaten = function () {
    return Array.from(kandidaten.keys());
  };
  api.gestapelt = function () {
    return Array.from(gestapelt.keys());
  };

  // Start nach den uebrigen Teilen des Buendels (die bauen beim Laden teils noch Markup um)
  function starten() {
    window.setTimeout(function () {
      neu(document);
    }, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
})();

;

/* ==== Teil: assets/mv-sortiment.mobil.js ==== */
/* MV Sortiment assets/mv-sortiment.mobil.js - Paket M-3 - 2026-10-08
 *
 * Mobiles Menue (snippets/mv-mobil-menue.liquid, Drawer #header-sidebar-menu mit der Klasse mv-mm). Inhaber
 * 08.10.2026: "Mobile menu irgendwie tot". Impacts NavigationDrawer (assets/theme.js, unveraendert) oeffnet und
 * schliesst den Drawer, haelt die Fokusfalle (Esc schliesst) und schaltet die Ebenen ueber button[data-panel]. Diese
 * Datei ergaenzt nur, was Impact mobil nicht tut:
 *   - aria-expanded am Bereichsknopf der Ebene 1: true fuer den geoeffneten Bereich, false nach Zurueck und nach dem
 *     Schliessen (dialog:after-hide);
 *   - Fokus beim Ebenenwechsel: nach dem Oeffnen eines Bereichs auf Zurueck, nach Zurueck wieder auf den Bereich.
 *     Erst wenn das Ziel sichtbar ist (Impact blendet die Ebenen per Animation ein; unsichtbare Elemente nehmen keinen
 *     Fokus an), hoechstens FRIST ms lang je Bild geprueft;
 *   - Drawer zu vor der Anfrage-Lightbox (snippets/mv-anfrage-modal.liquid oeffnet bei Klicks auf
 *     a[href*="anfrage=1"] und [data-mv-open-anfrage], Bubble-Phase auf document): sonst laege die Lightbox unter der
 *     Fokusfalle des Drawers, Klicks und Tab im Formular wuerden abgefangen;
 *   - Drawer zu bei Links auf einen Anker derselben Seite (sonst bliebe der Drawer ueber dem Ziel stehen); Klicks mit
 *     Zusatztaste (neuer Tab) lassen ihn offen.
 * Delegation auf document in der Capture-Phase, also vor Impacts Delegation am Drawer und vor der Lightbox. Der
 * Drawer haengt sich beim Oeffnen an body (Impact), deshalb keine Bindung an das Element. Waechter
 * window.__mvSortimentMobilMenue. Kein Speicher, keine sichtbaren Texte; diese Datei bleibt reines ASCII. Unter Node
 * (Tests _tests/m3-mobil-menue.test.mjs) liefert sie nur die reinen Funktionen ueber module.exports.
 *
 * Paket LZ-2d (2026-10-25, _docs/lz2-d-mobil-menue.md): die Seite liefert nur Kopf, minimale nav und Leiste
 * (data-mv-menue-geladen = nein | laedt | ja | fehler; ohne Attribut ist das volle Menue schon da). Das volle Menue
 * rendert die Kopf-Sektion selbst bei <Pfad>?section_id=<Kopf-Sektion>&page=SEITE (Section Rendering API); die
 * Kinder von #header-sidebar-menu aus der Antwort ersetzen die Kinder des Drawers. Ausloeser: erstes Oeffnen und Vorabruf im
 * Leerlauf nach load (nur bei sichtbarem Burger, ohne Save-Data/2G); eine Anfrage fuer alle Aufrufe; Fehler: minimale
 * nav bleibt, neuer Versuch beim Oeffnen (hoechstens VERSUCHE). Offener Drawer: Fokusfalle neu, Fokus an gleicher
 * Stelle.
 */
;(function () {
  'use strict';

  // Zaehler .2 = Paket LZ-2d (2026-10-25)
  var VERSION = '2026-10-08.2';
  var DRAWER = '.mv-mm';
  // Gleicher Selektor wie die Lightbox in snippets/mv-anfrage-modal.liquid
  var ANFRAGE = 'a[href*="anfrage=1"], [data-mv-open-anfrage]';
  var FRIST = 1500;

  // LZ-2d: dieselbe Zahl wie die Weiche mv_mm_voll in snippets/mv-mobil-menue.liquid
  var SEITE = 7171;
  var DRAWER_ID = 'header-sidebar-menu';
  var ZUSTAND = 'data-mv-menue-geladen';
  var BURGER = '[aria-controls="header-sidebar-menu"]';
  var VERSUCHE = 3;
  var LADEFRIST = 10000;
  // Elemente, die minimale nav und volles Menue gemeinsam haben (fuer den Fokus nach dem Einsetzen)
  var FOKUS_KLASSEN = ['mv-mm__schliessen', 'mv-mm__logo', 'mv-mm__aktion', 'mv-mm__bereich'];

  // ===========================================================================================
  // Reine Logik (ohne window und document; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).trim();
  }

  // data-panel von Impact: "1-2" -> { ebene: 1, nr: 2 }, "0" -> { ebene: 0, nr: null }, sonst null
  function panelZiel(wert) {
    var m = /^(\d+)(?:-(\d+))?$/.exec(text(wert));
    if (!m) return null;
    return { ebene: parseInt(m[1], 10), nr: m[2] === undefined ? null : parseInt(m[2], 10) };
  }

  // Oeffnet der Link die Anfrage-Lightbox? Dieselbe Regel wie ANFRAGE: Adresse enthaelt anfrage=1 oder Attribut
  function istAnfrage(href, hatAttribut) {
    return !!hatAttribut || text(href).indexOf('anfrage=1') !== -1;
  }

  // Zeigt der Link auf einen Anker derselben Seite? Gleicher Pfad und gleicher Suchteil wie ort (location), Anker
  // nicht leer; "#x" allein zaehlt immer. Ein anderer Suchteil laedt die Seite neu (kein Sprung im Dokument).
  function gleicheSeiteMitAnker(href, ort) {
    var h = text(href);
    var i = h.indexOf('#');
    if (i === -1 || i === h.length - 1) return false;
    var vor = h.slice(0, i);
    if (vor === '') return true;
    var m = /^(?:[a-z][a-z0-9+.-]*:)?\/\/[^\/?#]*(.*)$/i.exec(vor);
    var rest = m ? (m[1] || '/') : vor;
    var q = rest.indexOf('?');
    var pfad = q === -1 ? rest : rest.slice(0, q);
    var suche = q === -1 ? '' : rest.slice(q);
    return pfad === text(ort && ort.pathname) && suche === text(ort && ort.search);
  }

  // LZ-2d: Adresse fuer das volle Menue. pfad = Pfad der Seite (ohne Suchteil und Anker, damit link.current,
  // aria-current und der Rueckweg der Anmeldung wie auf der Seite gerendert werden); fremde oder leere Pfade -> "/"
  function menueUrl(pfad, sektionId) {
    var p = text(pfad).split('#')[0].split('?')[0];
    if (p.charAt(0) !== '/' || p.charAt(1) === '/') p = '/';
    return p + '?section_id=' + encodeURIComponent(text(sektionId)) + '&page=' + SEITE;
  }

  // LZ-2d: "shopify-section-sections--123__header" -> "sections--123__header", sonst null
  function sektionIdAusElementId(id) {
    var m = /^shopify-section-(.+)$/.exec(text(id));
    return m ? m[1] : null;
  }

  // LZ-2d: Vorabruf im Leerlauf? Nur solange nichts geladen oder versucht ist (nein), der Burger sichtbar ist (unter
  // 1150 px, Impacts lg:hidden) und die Verbindung nicht spart (Save-Data, 2G)
  function sollVorabrufen(u) {
    u = u || {};
    if (u.zustand !== 'nein') return false;
    if (u.burgerSichtbar !== true) return false;
    if (u.saveData === true) return false;
    return !/(^|-)2g$/.test(text(u.effectiveType));
  }

  var logik = {
    VERSION: VERSION,
    SEITE: SEITE,
    panelZiel: panelZiel,
    istAnfrage: istAnfrage,
    gleicheSeiteMitAnker: gleicheSeiteMitAnker,
    menueUrl: menueUrl,
    sektionIdAusElementId: sektionIdAusElementId,
    sollVorabrufen: sollVorabrufen
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Im Browser
  // ===========================================================================================

  if (window.__mvSortimentMobilMenue) return;
  var api = window.__mvSortimentMobilMenue = { version: VERSION, logik: logik };

  function sichtbar(el) {
    if (!el || !el.isConnected) return false;
    if (typeof el.checkVisibility === 'function') return el.checkVisibility({ checkVisibilityCSS: true, visibilityProperty: true });
    for (var x = el; x && x.nodeType === 1; x = x.parentElement) {
      if (x.hidden || window.getComputedStyle(x).display === 'none') return false;
    }
    return window.getComputedStyle(el).visibility !== 'hidden';
  }

  // Fokus setzen, sobald das Ziel sichtbar ist (je Bild geprueft, hoechstens FRIST ms)
  function fokusWennSichtbar(ziel) {
    if (!ziel) return;
    var start = Date.now();
    var naechstes = typeof window.requestAnimationFrame === 'function'
      ? function (f) { window.requestAnimationFrame(f); }
      : function (f) { window.setTimeout(f, 16); };
    (function versuch() {
      if (!ziel.isConnected) return;
      if (sichtbar(ziel)) {
        try { ziel.focus({ preventScroll: true }); } catch (_) { ziel.focus(); }
        return;
      }
      if (Date.now() - start > FRIST) return;
      naechstes(versuch);
    })();
  }

  // aria-expanded der Bereichsknoepfe: nur knopf offen (null = alle zu)
  function setzeOffen(drawer, knopf) {
    var knoepfe = drawer.querySelectorAll('button[data-panel^="1-"]');
    for (var i = 0; i < knoepfe.length; i++) knoepfe[i].setAttribute('aria-expanded', knoepfe[i] === knopf ? 'true' : 'false');
  }

  function schliesse(drawer) {
    if (drawer.hasAttribute('open') && typeof drawer.hide === 'function') drawer.hide();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var drawer = t.closest(DRAWER);
    if (!drawer) return;

    var knopf = t.closest('button[data-panel]');
    if (knopf) {
      var ziel = panelZiel(knopf.getAttribute('data-panel'));
      if (!ziel) return;
      if (ziel.ebene === 1 && ziel.nr !== null) {
        setzeOffen(drawer, knopf);
        var ebene = document.getElementById(knopf.getAttribute('aria-controls'));
        fokusWennSichtbar(ebene && ebene.querySelector('button[data-panel="0"]'));
      } else if (ziel.ebene === 0) {
        var offen = drawer.querySelector('button[data-panel^="1-"][aria-expanded="true"]');
        setzeOffen(drawer, null);
        fokusWennSichtbar(offen);
      }
      return;
    }

    // Anfrage-Lightbox: Drawer zuerst zu, die Lightbox oeffnet danach (Bubble-Phase)
    if (t.closest(ANFRAGE)) {
      schliesse(drawer);
      return;
    }

    var link = t.closest('a[href]');
    if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || (typeof e.button === 'number' && e.button !== 0)) return;
    if (gleicheSeiteMitAnker(link.getAttribute('href'), window.location)) schliesse(drawer);
  }, true);

  // Drawer geschlossen (Impact setzt die Ebenen zurueck): alle Bereiche zu
  document.addEventListener('dialog:after-hide', function (e) {
    var d = e.target;
    if (d && typeof d.matches === 'function' && d.matches(DRAWER)) setzeOffen(d, null);
  });

  api.schliessen = schliesse;

  // ===========================================================================================
  // LZ-2d: volles Menue nachladen
  // ===========================================================================================

  function drawerHolen() {
    return document.getElementById(DRAWER_ID);
  }

  // id der Kopf-Sektion: beim Start merken, solange der Drawer noch in der Sektion steht (Impact haengt ihn beim
  // Oeffnen an body); sonst ueber die Klasse der Kopf-Sektion (Schema "class": "shopify-section--header")
  var sektionId = null;
  function kopfSektionId() {
    if (sektionId) return sektionId;
    var d = drawerHolen();
    var sek = (d && typeof d.closest === 'function' && d.closest('.shopify-section')) || document.querySelector('.shopify-section--header');
    sektionId = sek ? sektionIdAusElementId(sek.id) : null;
    return sektionId;
  }
  kopfSektionId();

  // Volles Menue aus der Antwort: #header-sidebar-menu ohne minimale nav und mit Ebenen, sonst null
  function vollesMenueAus(html) {
    var doc = new window.DOMParser().parseFromString(String(html || ''), 'text/html');
    var d = doc.getElementById(DRAWER_ID);
    if (!d || d.querySelector('[data-mv-mm-minimal]') || !d.querySelector('.mv-mm__panels')) return null;
    return d;
  }

  function hole(url) {
    var abbruch = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var uhr = abbruch ? window.setTimeout(function () { abbruch.abort(); }, LADEFRIST) : null;
    var optionen = { credentials: 'same-origin' };
    if (abbruch) optionen.signal = abbruch.signal;
    return window.fetch(url, optionen).then(function (r) {
      if (!r || !r.ok) throw new Error('Status ' + (r && r.status));
      return r.text();
    }).then(function (html) {
      if (uhr) window.clearTimeout(uhr);
      var neu = vollesMenueAus(html);
      if (!neu) throw new Error('Antwort ohne volles Menue');
      return neu;
    }, function (fehler) {
      if (uhr) window.clearTimeout(uhr);
      throw fehler;
    });
  }

  // Adressen der Reihe nach: erst der Pfad der Seite, dann die Startseite (z. B. wenn der Pfad umleitet)
  function holeErstes(urls, i) {
    return hole(urls[i]).catch(function (fehler) {
      if (i + 1 < urls.length) return holeErstes(urls, i + 1);
      throw fehler;
    });
  }

  function fokusSchluessel(drawer, el) {
    if (!el || !drawer.contains(el)) return null;
    var mini = el.closest('.mv-mm__mini');
    if (mini) el = mini.querySelector('.mv-mm__bereich') || el;
    for (var i = 0; i < FOKUS_KLASSEN.length; i++) {
      var t = el.closest('.' + FOKUS_KLASSEN[i]);
      if (t && drawer.contains(t)) {
        return { klasse: FOKUS_KLASSEN[i], nr: Array.prototype.indexOf.call(drawer.querySelectorAll('.' + FOKUS_KLASSEN[i]), t) };
      }
    }
    return null;
  }

  function ersetzeKinder(el, knoten) {
    if (typeof el.replaceChildren === 'function') {
      el.replaceChildren.apply(el, knoten);
      return;
    }
    while (el.firstChild) el.removeChild(el.firstChild);
    for (var i = 0; i < knoten.length; i++) el.appendChild(knoten[i]);
  }

  function einsetzen(drawer, neu) {
    var schluessel = fokusSchluessel(drawer, document.activeElement);
    ersetzeKinder(drawer, Array.prototype.slice.call(neu.childNodes));
    drawer.setAttribute(ZUSTAND, 'ja');
    if (drawer.hasAttribute('open')) {
      // Impact legt die Falle beim ersten Oeffnen an (_focusTrap); neu einlesen, damit Tab die neuen Elemente kennt
      var falle = drawer._focusTrap;
      if (falle && typeof falle.updateContainerElements === 'function') {
        try { falle.updateContainerElements(drawer); } catch (_) {}
      }
      if (schluessel) {
        var ziel = drawer.querySelectorAll('.' + schluessel.klasse)[schluessel.nr] || drawer.querySelector('.mv-mm__bereich');
        fokusWennSichtbar(ziel);
      }
    }
    if (typeof window.CustomEvent === 'function') drawer.dispatchEvent(new window.CustomEvent('mv-mm:geladen', { bubbles: true }));
  }

  var laufend = null;
  var versuche = 0;

  // Laedt das volle Menue einmal; gleichzeitige Aufrufe teilen die Anfrage. Ergebnis: Promise auf true (eingesetzt
  // oder schon da) bzw. false (nicht moeglich oder Fehler; die minimale nav bleibt)
  function laden() {
    var drawer = drawerHolen();
    if (!drawer || !drawer.hasAttribute(ZUSTAND)) return Promise.resolve(!!drawer);
    if (drawer.getAttribute(ZUSTAND) === 'ja') return Promise.resolve(true);
    if (laufend) return laufend;
    if (versuche >= VERSUCHE) return Promise.resolve(false);
    if (typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return Promise.resolve(false);
    var id = kopfSektionId();
    if (!id) {
      drawer.setAttribute(ZUSTAND, 'fehler');
      return Promise.resolve(false);
    }
    versuche += 1;
    drawer.setAttribute(ZUSTAND, 'laedt');
    var start = window.location.pathname;
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var urls = [menueUrl(start, id)];
    if (menueUrl(wurzel, id) !== urls[0]) urls.push(menueUrl(wurzel, id));
    laufend = holeErstes(urls, 0).then(function (neu) {
      einsetzen(drawer, neu);
      return true;
    }).catch(function () {
      if (drawer.getAttribute(ZUSTAND) !== 'ja') drawer.setAttribute(ZUSTAND, 'fehler');
      return false;
    }).then(function (ok) {
      laufend = null;
      return ok;
    });
    return laufend;
  }

  function vorabruf() {
    var drawer = drawerHolen();
    if (!drawer) return;
    var verbindung = (window.navigator && window.navigator.connection) || {};
    if (sollVorabrufen({
      zustand: drawer.getAttribute(ZUSTAND),
      burgerSichtbar: sichtbar(document.querySelector(BURGER)),
      saveData: verbindung.saveData === true,
      effectiveType: verbindung.effectiveType || ''
    })) laden();
  }

  function imLeerlauf(f) {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(f, { timeout: 4000 });
    else window.setTimeout(f, 2000);
  }

  // Erstes Oeffnen: schon beim Druecken auf den Burger anfangen; toggle deckt andere Wege zum Oeffnen ab
  function beimBurger(e) {
    var t = e.target;
    if (t && typeof t.closest === 'function' && t.closest(BURGER)) laden();
  }
  document.addEventListener('pointerdown', beimBurger, true);
  document.addEventListener('click', beimBurger, true);
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.id === DRAWER_ID && typeof d.hasAttribute === 'function' && d.hasAttribute('open')) laden();
  }, true);

  if (document.readyState === 'complete') imLeerlauf(vorabruf);
  else window.addEventListener('load', function () { imLeerlauf(vorabruf); });

  api.menueLaden = laden;
})();

;

/* ==== Teil: assets/mv-sortiment.r2b.js ==== */
/* MV Sortiment assets/mv-sortiment.r2b.js - Paket R-2b - 2026-10-13
 *
 * Bestaetigung "Bestellung als Unternehmer" im Warenkorb (sections/main-cart.liquid) und im Drawer
 * (sections/cart-drawer.liquid). Rechtspruefung 12.10.2026 Befund H-7 (Ausschluss von Verbrauchern mit
 * Kontrollmassnahme im Bestellbereich, BGH I ZR 60/16; Inhaber: "Ja go ohne Anwalt"). Doku:
 * _docs/r2b-unternehmer-garantie.md. Teil von assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in
 * beliebiger Reihenfolge mit den anderen Teilen; nur Delegation auf document, kein Inline-Skript.
 *
 * Markup (Liquid): input[data-mv-unternehmer] (checkbox, required, nicht vorausgewaehlt, im Formular der
 * Kassen-Knoepfe; Name attributes[Bestellung als Unternehmer] -> Bestellattribut), Kassen-Knopf [name="checkout"] und
 * Express-Knoepfe [data-mv-unternehmer-express] (im Liquid hidden) im selben Formular.
 * Ohne Skript: required verhindert das Absenden, die Express-Knoepfe bleiben verborgen.
 * Mit Skript: solange das Kaestchen leer ist, sind die Kassen-Knoepfe disabled und die Express-Knoepfe hidden; ist es
 * gesetzt, sind beide frei. Abgleich beim Laden, bei change, nach Impacts Austausch des Drawer-Fusses (cart:change,
 * cart:refresh: MutationObserver, ein Lauf je Frame) und bei pageshow (Rueckkehr aus dem Verlauf). Kein Speicher
 * (kein localStorage, kein sessionStorage, kein Cookie): nach einem Austausch ist das Kaestchen wieder leer.
 * Fehlt ein Element, passiert nichts (kein Fehler). Kommentare und Datei ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-13.1';
  var KAESTCHEN = 'input[data-mv-unternehmer]';
  var KASSE = 'button[name="checkout"], input[name="checkout"]';
  var EXPRESS = '[data-mv-unternehmer-express]';

  // ===========================================================================================
  // Reine Logik
  // ===========================================================================================

  // Zustand der Knoepfe zu einem Kaestchen: nur ein gesetztes Kaestchen (true) gibt die Kasse frei
  function zustand(gesetzt) {
    var frei = gesetzt === true;
    return { kasseGesperrt: !frei, expressVerborgen: !frei };
  }

  var logik = { VERSION: VERSION, KAESTCHEN: KAESTCHEN, KASSE: KASSE, EXPRESS: EXPRESS, zustand: zustand };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.unternehmer) return;

  function formularVon(k) {
    if (!k) return null;
    if (k.form) return k.form;
    return typeof k.closest === 'function' ? k.closest('form') : null;
  }

  // Ein Kaestchen abgleichen: Kassen- und Express-Knoepfe in seinem Formular
  function abgleichen(k) {
    var form = formularVon(k);
    if (!form || typeof form.querySelectorAll !== 'function') return false;
    var z = zustand(k.checked === true);
    var kasse = form.querySelectorAll(KASSE);
    for (var i = 0; i < kasse.length; i++) kasse[i].disabled = z.kasseGesperrt;
    var express = form.querySelectorAll(EXPRESS);
    for (var j = 0; j < express.length; j++) express[j].hidden = z.expressVerborgen;
    return true;
  }

  // Alle Kaestchen unter einer Wurzel (Standard: das Dokument); Rueckgabe = Zahl der Kaestchen
  function alle(wurzel) {
    var w = wurzel && typeof wurzel.querySelectorAll === 'function' ? wurzel : document;
    var liste = w.querySelectorAll(KAESTCHEN);
    for (var i = 0; i < liste.length; i++) abgleichen(liste[i]);
    return liste.length;
  }

  function enthaeltKaestchen(knoten) {
    if (!knoten || knoten.nodeType !== 1) return false;
    if (typeof knoten.matches === 'function' && knoten.matches(KAESTCHEN)) return true;
    return typeof knoten.querySelector === 'function' && knoten.querySelector(KAESTCHEN) !== null;
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    var lauf = function () {
      geplant = false;
      alle(document);
    };
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(lauf);
    else window.setTimeout(lauf, 0);
  }

  document.addEventListener('change', function (e) {
    var t = e && e.target;
    if (t && typeof t.matches === 'function' && t.matches(KAESTCHEN)) abgleichen(t);
  });

  // Impact ersetzt den Fuss des Drawers (Formular mit Kaestchen und Kasse) nach jeder Aenderung am Warenkorb
  if (typeof window.MutationObserver === 'function' && document.documentElement) {
    new window.MutationObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        var neu = eintraege[i].addedNodes || [];
        for (var j = 0; j < neu.length; j++) {
          if (enthaeltKaestchen(neu[j])) {
            planen();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function () {
    alle(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      alle(document);
    });
  } else {
    alle(document);
  }

  MV.unternehmer = { version: VERSION, logik: logik, abgleichen: alle };
})();

;

/* ==== Teil: assets/mv-sortiment.suche.js ==== */
/* MV Sortiment assets/mv-sortiment.suche.js - Agent D2-E - 2026-10-05
 *
 * Suchlade (sections/search-drawer.liquid, Zeilen aus snippets/predictive-search-result-item.liquid).
 * Impacts Custom Elements (search-drawer, predictive-search in assets/theme.js) bleiben unangetastet; dieses Skript
 * ergaenzt nur zwei Dinge:
 *  1. Chips [data-mv-suche-begriff] in der Lade (Beliebte Suchen vor dem Tippen, Suchvorschlaege in den Treffern):
 *     ein normaler Klick schreibt den Begriff ins Feld q des Formulars und loest ein input-Ereignis aus. Darauf hoert
 *     Impacts predictive-search (debounce 280 ms) und holt /search/suggest - die Suche selbst baut hier niemand nach.
 *     Mit Zeigegeraet (pointer: fine) bekommt das Feld den Fokus, auf Touch nicht (die Tastatur verdeckte sonst die
 *     Treffer). Klicks mit Strg/Cmd/Umschalt/Alt oder Mittelklick bleiben Links (neuer Tab auf die Suchseite);
 *     ohne Skript fuehrt der Link auf /search?q=...
 *  2. Ansage: Impact ersetzt beim Tippen das Element [slot="results"]; ein MutationObserver liest danach den
 *     versteckten Statustext [data-mv-suche-status] ("n Treffer fuer ...") und schreibt ihn in die feste Live-Region
 *     [data-mv-suche-ansage] der Lade. Eingefuegte Live-Regionen sagen Screenreader oft nicht an.
 * Delegation auf document (click); Theme-Editor: shopify:section:load beobachtet neu geladene Laden.
 * Laedt allein und in beliebiger Reihenfolge als Teil von assets/mv-sortiment.js (_build/konkat.sh), defer-faehig.
 * Unter Node (Tests) liefert die Datei nur die reinen Funktionen. Kommentare ASCII, keine sichtbaren Texte im Skript.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-05.1';

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  // Leerraum zusammenfassen, Raender weg (Statustext fuer die Ansage)
  function normalisiere(text) {
    return String(text == null ? '' : text).replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  // Nur ein normaler Linksklick ohne Modifier wird abgefangen
  function abfangen(e) {
    if (!e || e.defaultPrevented) return false;
    if (e.button !== undefined && e.button !== 0) return false;
    return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  }

  var api = {
    VERSION: VERSION,
    normalisiere: normalisiere,
    abfangen: abfangen
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.suche) return;
  MV.suche = api;

  var LADE = '.mv-suche';
  var ERGEBNISSE = '.mv-suche__ergebnisse';

  function zeigegeraet() {
    try {
      return typeof window.matchMedia === 'function' && window.matchMedia('(pointer: fine)').matches;
    } catch (e) {
      return false;
    }
  }

  function feldVon(el) {
    var form = el && el.closest ? el.closest('form') : null;
    if (!form || !form.elements) return null;
    var feld = form.elements.namedItem ? form.elements.namedItem('q') : form.elements.q;
    return feld && feld.tagName === 'INPUT' ? feld : null;
  }

  function begriffSetzen(feld, begriff) {
    feld.value = begriff;
    if (zeigegeraet()) {
      feld.focus();
      try { feld.setSelectionRange(begriff.length, begriff.length); } catch (e) { /* Feldtyp ohne Auswahl */ }
    }
    var ereignis;
    try {
      ereignis = new Event('input', { bubbles: true });
    } catch (e) {
      ereignis = document.createEvent('Event');
      ereignis.initEvent('input', true, false);
    }
    feld.dispatchEvent(ereignis);
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var chip = ziel.closest('[data-mv-suche-begriff]');
    if (!chip || !chip.closest(LADE) || !abfangen(e)) return;
    var begriff = normalisiere(chip.getAttribute('data-mv-suche-begriff'));
    var feld = feldVon(chip);
    if (!begriff || !feld) return;
    e.preventDefault();
    begriffSetzen(feld, begriff);
  });

  // Statustext der aktuellen Treffer in die feste Live-Region der Lade
  function ansagen(ergebnisse) {
    var form = ergebnisse.closest ? ergebnisse.closest('form') : null;
    var region = form ? form.querySelector('[data-mv-suche-ansage]') : null;
    if (!region) return;
    var status = ergebnisse.querySelector('[slot="results"] [data-mv-suche-status]');
    var text = status ? normalisiere(status.textContent) : '';
    if (region.textContent !== text) region.textContent = text;
  }

  var beobachtet = typeof WeakSet === 'function' ? new WeakSet() : null;

  function beobachten(bereich) {
    if (typeof MutationObserver !== 'function' || !bereich || !bereich.querySelectorAll) return;
    var liste = Array.prototype.slice.call(bereich.querySelectorAll(LADE + ' ' + ERGEBNISSE));
    liste.forEach(function (ergebnisse) {
      if (beobachtet ? beobachtet.has(ergebnisse) : ergebnisse.__mvSucheBeobachtet) return;
      if (beobachtet) beobachtet.add(ergebnisse);
      else ergebnisse.__mvSucheBeobachtet = true;
      new MutationObserver(function () { ansagen(ergebnisse); }).observe(ergebnisse, { childList: true });
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    beobachten(e.target);
  });

  function bereit() {
    beobachten(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bereit);
  else bereit();
})();

;
